// @flow
import k from "./keys";

export default {
  [k._]: `:`,
  [k._1]: `(`,
  [k._2]: `)`,
  [k.LIGHT]: `光`,
  [k.ANGEL]: `天使`,
  [k.DARK]: `暗`,
  [k.DEMON]: `恶魔`,
  [k.SELECT_ALL]: `全选`,
  [k.DESELECT_ALL]: `取消全选`,
  [k.ALSBVYETHVN]: `alsbvyethvn`,
  [k.ALASKA]: `alaska`,
  [k.BSKJFH_KSJLHFVKLFSJB]: `bskjfh ksjlhfvklfsjb`,
  [k.CPQWHG_SKUGBHOWSFVJH]: `cpqwhg skugbhowsfvjh`,
  [k.DWQEFHKDVB_LASHDVSDALN_SJBVKSF]: `dwqefhkdvb lashdvsdaln sjbvksfjbv`,
  [k.SDV_ASODJHVSF_SLDHGVKSUFGV]: `sdv ;asodjhvsf sldhgvksufgv`,
  [k.KJSBFV]: `kjsbfv`,
  [k.POWQJIF]: `powqjif`,
  [k.XCUYWE]: `xcuywe`,
  [k.POIQRF]: `poiqrf`,
  [k.LABEL]: `标签`,
  [k.NONE]: `无`,
  [k.SYSTEM]: `系统`,
  [k._3]: `0`,
  [k.CHECKBOX]: `复选框`,
  [k.LOADING_CHART]: `加载图表`,
  [k.ADD_A_CHART]: `+ 添加图表`,
  [k.CREATED_BY]: `创建者：`,
  [k.DELETE_DASHBOARD]: `删除仪表板`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DELET]: `您确定要删除`,
  [k.PINNED_CHARTS_WILL_NOT_BE_DELE]: `固定的图表不会被删除。`,
  [k.CANCEL]: `取消`,
  [k.DELETE]: `删除`,
  [k.DASHBOARD]: `仪表板`,
  [k.CREATE_NEW]: `+ 创建新的`,
  [k.REFRESH_DASHBOARD]: `刷新仪表板`,
  [k.DELETE_DASHBOARD1]: `删除仪表板`,
  [k.BUTTON]: `按钮`,
  [k.NO_DASHBOARD_SELECTED]: `未选择仪表板`,
  [k.SELECT]: `选择`,
  [k.ADDBUTTON]: `添加按钮`,
  [k.U_B_ADD]: `\u002B 添加`,
  [k._4]: ``,
  [k._5]: `-`,
  [k.YOU_ARE_NOT_AUTHORIZED_CLICK]: `您未获授权。点击此处查看详情。`,
  [k.VIEW_REMAINING_SIGNATORIES]: `查看剩余签署人`,
  [k.ADD]: `添加`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_CANCE]: `您确定要取消审批吗？这将解锁检查表字段，更改状态并废弃先前的审批。`,
  [k.PLEASE_ENTER_A_COMMENT]: `请输入评论`,
  [k.NO]: `否`,
  [k.YES]: `是`,
  [k.CANCELLATION]: `取消 -`,
  [k.HIDE]: `隐藏`,
  [k.SHOW]: `显示`,
  [k.LINE_THROUGH]: `删除线`,
  [k.INCOMPLETE]: `未完成`,
  [k.CONFIGURE_AD_HOC_SIGNATURE]: `配置临时签名`,
  [k.NUMBER_OF_SIGNATORIES]: `签署人数量`,
  [k.USERS]: `用户`,
  [k.GROUPS]: `群组`,
  [k.CONFIRM]: `确认`,
  [k.REQUEST_APPROVAL]: `请求审批`,
  [k.ADD_SIGNATURE]: `+ 添加签名`,
  [k.APPLY_YOUR_SIGNATURE]: `应用您的签名`,
  [k.TYPE]: `类型`,
  [k.APPROVAL]: `批准`,
  [k.REJECTION]: `拒绝`,
  [k.EMAIL_ID]: `邮箱ID`,
  [k.OTP_SENT_AGAIN_PLEASE_CHECK_Y]: `OTP已重新发送。请检查您的邮箱。`,
  [k.OTP_SENT_TO_THE_MENTIONED_EMAI]: `OTP已发送到提及的电子邮件地址。`,
  [k.RESEND]: `重新发送`,
  [k.PASSWORD]: `密码`,
  [k.OTP]: `OTP`,
  [k.INCORRECT_OTP]: `OTP不正确`,
  [k.GENERATE_OTP]: `生成OTP`,
  [k.APPROVAL1]: `批准`,
  [k.COMMENT]: `评论`,
  [k.UPLOAD_YOUR_OWN_SIGNATURE]: `上传您自己的签名`,
  [k.ATTACH_FILE]: `附加文件`,
  [k.USE_SYSTEM_GENERATED_SIGNATURE]: `使用系统生成的签名`,
  [k.CONFIRM_AND_SIGN]: `确认并签名`,
  [k.RED]: `红色`,
  [k.ENTER_EMAIL]: `输入邮箱`,
  [k.UPLOAD_NEW]: `上传新的`,
  [k.UPLOAD]: `上传`,
  [k.BY]: `由：`,
  [k.YOU]: `您`,
  [k.ID]: `ID：`,
  [k.MEMBERS]: `成员`,
  [k.MEMBER]: `成员`,
  [k.USER]: `用户-`,
  [k.GROUP]: `群组-`,
  [k.REMOVE_SELECTED_USER]: `删除选定的用户`,
  [k.LIST]: `列表`,
  [k.USER1]: `用户`,
  [k.GROUP1]: `群组`,
  [k.LINK]: `链接`,
  [k.ENTER_USER_S_EMAIL]: `输入用户的邮箱`,
  [k.ADD_NEW_USER]: `添加新用户`,
  [k.SELECT_USERS]: `选择用户`,
  [k.ENTER_VALID_EMAIL]: `输入有效的邮箱`,
  [k.TOGGLEUSERDROPDOWN]: `切换用户下拉菜单`,
  [k.REMOVEUSER]: `删除用户`,
  [k.DECREMENT]: `减少`,
  [k.NO_USER_SELECTED]: `未选择用户`,
  [k.ADD1]: `添加`,
  [k.ENTER_TITLE]: `输入标题`,
  [k.SEARCH]: `搜索`,
  [k.SHOWING_RESULTS_SEARCH_TO_FIND]: `显示12个结果。搜索以查找其他结果。`,
  [k.PRIVATE]: `私密`,
  [k.LOADING]: `加载中...`,
  [k.CREATE]: `+ 创建`,
  [k.REMOVE]: `移除`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_REMOV]: `您确定要移除`,
  [k.FROM_THE_CHECKLIST]: `从检查表中?`,
  [k.CONVERSATION]: `对话`,
  [k.VIEW_ALL_FIELDS]: `查看所有字段`,
  [k.UPDATE]: `更新`,
  [k._7]: `#`,
  [k.NO_TITLE]: `无标题`,
  [k.MAKE_AS_CURRENT_REVISION]: `设为当前修订版本`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_MAKE]: `您确定要使`,
  [k.AS_THE_CURRENT_REVISION]: `成为当前修订版本吗?`,
  [k.CURRENT_REVISION]: `当前修订版本`,
  [k.CURRENTREVISION]: `当前修订版本`,
  [k.CURRENT]: `当前`,
  [k.MAKE_CURRENT_REVISION]: `设为当前修订版本`,
  [k.MAKE_CURRENT]: `设为当前`,
  [k.VIEWING_NOW]: `正在查看`,
  [k.NO_TITLE1]: `无标题`,
  [k.DONE]: `完成`,
  [k.MORE]: `...更多`,
  [k.UNIFIZE_UNIFIZEBLUE]: `unifize_unifizeBlue`,
  [k.CREATE_NEW1]: `创建新的`,
  [k.DOCUMENT]: `文档`,
  [k.ENTER_TITLE1]: `输入标题`,
  [k.NOTE_YOUR_DOCUMENT_WILL_BE_SH]: `注意：您的文档将与此对话的所有参与者共享`,
  [k.CREATE1]: `创建`,
  [k.FILEICONS]: `文件图标`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DELET1]: `您确定要删除 "`,
  [k.INLINE_BLOCK]: `内联块`,
  [k._9]: `.`,
  [k._10]: `"`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_REMOV1]: `您确定要移除此文件吗?`,
  [k.REMOVE_FROM_CHECKLIST]: `从检查表中移除`,
  [k.FROM_UNIFIZE_FILE_STORE]: `从Unifize文件存储中`,
  [k.UPLOADING_FILE]: `正在上传文件...`,
  [k.OTHERS]: `其他`,
  [k.PREVIEW]: `预览`,
  [k.EDIT]: `编辑3`,
  [k.FILECONTAINER]: `文件容器`,
  [k.FILENAME]: `文件名`,
  [k._11]: `|`,
  [k.UPLOADED_ON]: `上传于：`,
  [k.NO_PREVIEW_AVAILABLE]: `无可用预览`,
  [k.CHECKLIST]: `检查表`,
  [k.PICK_SOURCE]: `选择来源`,
  [k.UNIFIZE_FILE_STORE]: `Unifize文件存储`,
  [k.COMPUTER]: `计算机`,
  [k.NO_SOURCE_SELECTED]: `未选择来源`,
  [k._12]: `,`,
  [k.SELECT_FORM]: `+ 选择表单`,
  [k.AUTO_SELECT_ALL_REVISIONS]: `自动选择所有修订版本`,
  [k.SELECT_MANUALLY]: `手动选择`,
  [k.BACK]: `返回`,
  [k.AUTO_SELECT_ALL_REVISIONS_IS]: `自动选择所有修订版本是`,
  [k.EDIT_SELECTED_REVISION_S]: `编辑选定的修订版本`,
  [k.ALL_REVISIONS]: `所有修订版本`,
  [k.SELECT_REVISIONS]: `选择修订版本`,
  [k.REMOVE_LINK_OR_REASSIGN_REVISI]: `移除链接或重新分配修订版本?`,
  [k.THIS_CONVERSATION_HAS_MULTIPLE]: `此对话有多个修订版本。您想要移除与所有这些的链接吗?`,
  [k.REASSIGN_REVISIONS]: `重新分配修订版本`,
  [k.REMOVE_LINK]: `移除链接`,
  [k.ADDCONVERSATIONBUTTON]: `添加对话按钮`,
  [k.AUTO_SELECT_CURRENT_REVISION]: `自动选择当前修订版本`,
  [k.AUTO_SELECT_CURRENT_REVISION_I]: `自动选择当前修订版本是`,
  [k.EDIT_SELECTED_REVISION]: `编辑选定的修订版本`,
  [k.SELECT_REVISION]: `选择修订版本`,
  [k.NEW_ITEM]: `新项目`,
  [k.ITEM]: `项目 "`,
  [k.SELECT_CHECKLIST_FIELDS]: `选择检查表字段`,
  [k.CREATE_VERSION]: `创建版本`,
  [k.CREATE_NEW_REVISION]: `创建新的修订版本`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_CREAT]: `您确定要创建修订版本吗?`,
  [k.CANCELLERS]: `取消者`,
  [k.ALLOWED_CANCELLERS]: `允许的取消者`,
  [k.ALLOWED_SIGNATORIES]: `允许的签署人`,
  [k.ROLES]: `角色`,
  [k.FIELDS]: `字段`,
  [k.SPECIFIC_USERS]: `特定用户`,
  [k.SELECT_THE_DATA_TO_COPY_TO_NEW]: `选择要复制到新修订版本的数据`,
  [k.CHECKLIST_AND_FORM_DATA]: `检查表和表单数据`,
  [k.SELECT_FIELDS]: `选择字段`,
  [k.REVISION_NOTES]: `修订说明`,
  [k.WHY_ARE_YOU_MAKING_THIS_REVISI]: `您为什么要进行此修订?`,
  [k.CREATE_REVISION]: `创建修订版本`,
  [k.REVISION]: `修订版本`,
  [k.CREATE_REVISION1]: `创建修订版本`,
  [k.CONVERSATION1]: `对话`,
  [k.NO_MATCHING_RESULTS]: `没有匹配的结果。`,
  [k.ADD_NEW_USER1]: `+ 添加新用户`,
  [k.CHECKLISTREMOVE]: `检查表移除`,
  [k.UPLOAD_NEW_VERSION]: `上传新版本`,
  [k.DOWNLOAD]: `下载`,
  [k.MMM_DD_YYYY]: `MMM DD, YYYY`,
  [k.NOT_ASSIGNED]: `未分配`,
  [k.SEND_AN_EMAIL_TO_CONVERSATION]: `发送电子邮件到对话`,
  [k.FILES]: `文件`,
  [k.DATA]: `数据`,
  [k.INFO]: `信息`,
  [k.CHECKLIST1]: `检查表`,
  [k.JSON_FOR_ADOBE]: `Adobe的JSON`,
  [k.JSON_FOR_PDFGENERATORAPI]: `PDFGeneratorAPI的JSON`,
  [k.SAVE]: `保存`,
  [k.REFRESH]: `刷新`,
  [k.TO_SEE_LATEST_CHECKLIST_DATA]: `查看最新的检查表数据`,
  [k.CREATOR]: `创建者`,
  [k.DATE_CREATED]: `创建日期`,
  [k.MMM_DD_YYYY_HH_MM_A]: `MMM DD, YYYY hh:mm a`,
  [k.AGE]: `时长`,
  [k.DAYS]: `天`,
  [k.DAYS1]: `天`,
  [k.PARENT1]: `父级：`,
  [k.CHILD]: `，子级：`,
  [k.LEAVE_CONVERSATION]: `离开对话`,
  [k.PUBLIC]: `公开`,
  [k.HIDE_CHAT_CONTENT]: `隐藏聊天内容`,
  [k.HIDE_EVERYTHING]: `隐藏所有内容`,
  [k.ADD_NEW_FIELDS]: `添加新字段`,
  [k.PRIVACY_SETTINGS]: `隐私设置`,
  [k.NORMAL]: `正常`,
  [k.MAKE_PRIVATE]: `设为私密`,
  [k.ONLY_PARTICIPANTS_CAN_ACCESS_T]: `只有参与者才能访问这些记录`,
  [k.HIDE_ONLY_CHAT_CONTENT]: `仅隐藏聊天内容`,
  [k.ONLY_THE_CONTENTS_OF_THE_CONVE]: `只有记录的内容会被隐藏。记录标题、状态和所有者对其他用户可见。`,
  [k.CONVERSATIONS_WILL_BE_VISIBLE]: `记录只对参与者、管理员和白名单用户可见。`,
  [k.REMINDERS]: `提醒`,
  [k.REMINDERS1]: `提醒`,
  [k.WHATSAPP]: `WhatsApp`,
  [k.ON]: `开`,
  [k.OFF]: `关`,
  [k.LEFTHANDLE]: `左侧句柄`,
  [k.DOWNLOAD_PROHIBITED]: `禁止下载`,
  [k.DOWNLOADING_FILES_IS_PROHIBITE]: `管理员已禁止下载文件。`,
  [k.WE_RE_SORRY_SOMETHING_S_GONE]: `很抱歉 — 出现了问题。`,
  [k.OUR_TEAM_HAS_BEEN_NOTIFIED_BU]: `我们的团队已收到通知，但`,
  [k.LET_US_KNOW]: `请告诉我们`,
  [k.WHAT_HAPPENED]: `发生了什么。`,
  [k.BROWSER]: `浏览器：`,
  [k.VERSION]: `版本：`,
  [k.UID]: `UID：`,
  [k.URL]: `URL：`,
  [k.ORG]: `组织：`,
  [k.TRY_AGAIN]: `重试`,
  [k.CHROME]: `Chrome`,
  [k.FIREFOX]: `Firefox`,
  [k.MICROSOFT_INTERNET_EXPLORER]: `Microsoft Internet Explorer`,
  [k.SAFARI]: `Safari`,
  [k.EDGE]: `Edge`,
  [k.OPERA]: `Opera`,
  [k.COULD_NOT_FETCH_CHAT_ROOMS]: `无法获取聊天室：`,
  [k.RETRY]: `重试`,
  [k._13]: `+`,
  [k.SCROLLCOLUMN_D]: `scrollColumn2d`,
  [k.HOME]: `首页`,
  [k.WELCOME_BACK]: `欢迎回来！`,
  [k.LOADING_USER]: `加载用户中...`,
  [k.YOUR_HOME_SCREEN_HAS_NOT_BEEN]: `您的组织管理员尚未设置您的主屏幕。`,
  [k.UNIFIZE_HOME_NOT_SET_UP]: `Unifize主页未设置`,
  [k.CONTACT_YOUR_ORG_ADMIN_TO_SET]: `联系您的组织管理员来设置您的Unifize主页`,
  [k.HERE_S_WHAT_S_GOING_ON_AT]: `以下是正在进行的事情`,
  [k.CLOSE1]: `关闭`,
  [k.SKIP_INVITE]: `跳过邀请`,
  [k.DO_NOT_ADD_CREATOR_AS_OWNER]: `不要将创建者添加为所有者`,
  [k.DO_NOT_ADD_CREATOR_AS_PARTICIP]: `不要将创建者添加为参与者`,
  [k.DO_NOT_SEND_CONFIRMATION_TO_SE]: `不要向发送者发送确认`,
  [k.DISABLE_AUTO_NUMBER]: `禁用自动编号`,
  [k.CONVERT_TO_FEED]: `转换为信息流`,
  [k.SLA_IN_DAYS_AUTO_FILL_DUE_DAT]: `SLA天数（创建对话时自动填充截止日期）`,
  [k.EMAILS_SENT_HERE_WILL_START_A]: `发送到此处的电子邮件将启动一个新实例`,
  [k.DO_NOT_SHOW_THIS_PROCESS_IN]: `不要在 + 新建中显示此流程`,
  [k.DO_NOT_INVITE_SENDER_TO_CONVER]: `不要邀请发送者加入对话`,
  [k.NEXT_COUNT]: `下一个计数`,
  [k.NOTIFY_GROUPS]: `通知群组`,
  [k.ENABLE_PAGINATION_IN_PROCESS_T]: `在流程表中启用分页`,
  [k.ENABLE_PAGINATION_IN_REPORTS]: `在报表中启用分页`,
  [k.ALLOW_ADHOC_ARCHIVING]: `允许临时存档`,
  [k.ADD_FIELD]: `添加字段`,
  [k.FIELD1]: `字段`,
  [k.DOWNLOAD_SAMPLE_CSV]: `下载示例CSV`,
  [k.ADD_FIELD1]: `添加字段`,
  [k.BEHAVIOR]: `行为`,
  [k.MANDATORY_IF_NOT_HIDDEN]: `如果不隐藏则必填`,
  [k.VALUE]: `值`,
  [k.CONDITION]: `条件`,
  [k.FORM_DATA]: `表单数据`,
  [k.CHECKLIST_DATA]: `检查表数据`,
  [k.CONVERSATION_DATA]: `对话数据`,
  [k.SHOW_UNTIL_CONDITION_MET]: `显示直到满足条件`,
  [k.HIDDEN_UNTIL_CONDITION_MET]: `隐藏直到满足条件`,
  [k.MANDATORY_UNTIL_CONDITION_MET]: `必填直到满足条件`,
  [k.DISABLE_UNTIL_CONDITION_MET]: `禁用直到满足条件`,
  [k.COPY]: `复制`,
  [k.ADD_CONDITION_AND]: `+ 添加条件（与）`,
  [k.ADD_NEW_CONDITION]: `+ 添加新条件`,
  [k.DELETE_FIELD]: `删除字段`,
  [k._17]: `?`,
  [k.FIELDNAMEINPUT]: `字段名称输入-`,
  [k.FIELDSETTINGS]: `字段设置`,
  [k.FORM]: `表单`,
  [k.NOT_ALLOWED]: `不允许`,
  [k.OLDSETTINGS]: `旧设置`,
  [k.PROMPT_WHOM]: `提示谁`,
  [k.WHEN]: `何时`,
  [k.CREATE_RULES_TO_PROMPT_USERS_T]: `创建规则以提示用户完成此步骤。指定的用户将在对话中查看这些字段。`,
  [k.CREATE_NEW_RULE]: `创建新规则`,
  [k.AUTO_ARCHIVE]: `自动存档`,
  [k.SEND_MESSAGE]: `发送消息`,
  [k.CHANGE_STATUS_TO]: `将状态更改为`,
  [k.ADD_PARTICIPANTS]: `添加参与者`,
  [k.REMOVE_PARTICIPANTS]: `移除参与者`,
  [k.UPDATE_PRIVACY]: `更新隐私`,
  [k.WHITELIST]: `白名单`,
  [k.DON_T_CHANGE]: `不要更改`,
  [k.MAKE_PUBLIC]: `设为公开`,
  [k.UNARCHIVE]: `取消归档`,
  [k.IS_NOT_SUPPORTED]: `不支持`,
  [k.GET_SIGNATURE_OF_ANY]: `获取任何`,
  [k.USER_S]: `用户的签名`,
  [k.SELECT_AD_HOC]: `选择临时`,
  [k.WHO_CAN_CANCEL]: `谁可以取消`,
  [k.WHEN_CAN_THEY_CANCEL]: `何时可以取消`,
  [k.HIDE_WHEN_INACTIVE]: `非活动时隐藏`,
  [k.DISABLE_WHEN_INACTIVE]: `非活动时禁用`,
  [k.CONTINUE_TO_LOCK_FIELDS_UNDER]: `继续锁定先前审批下的字段`,
  [k.LOCK_CHECKLIST_FIELDS_DURING_A]: `在审批/拒绝期间和之后锁定检查表字段：`,
  [k.LOCK_STATUS_PREVENT_USERS_FRO]: `锁定状态（防止用户更改状态）`,
  [k.CHANGE_OWNER_TO]: `将所有者更改为`,
  [k.SEND_A_MESSAGE]: `发送消息`,
  [k.MARK_REVISION_AS_CURRENT]: `将修订版本标记为当前版本`,
  [k.CANCEL_ALL_PREVIOUS_APPROVALS]: `取消所有先前的批准（在层次结构内）`,
  [k.SELECT_CHECKLIST_FIELD]: `选择检查表字段`,
  [k.DELETED_FIELD]: `已删除字段`,
  [k.PROCESS]: `流程`,
  [k.EMBEDDED_FIELDS]: `嵌入字段`,
  [k.ADD_EMBEDED_FIELD]: `添加嵌入字段`,
  [k.ONLY_ALLOW_CREATING_NEW_CONVER]: `只允许创建新对话`,
  [k.ONLY_ALLOW_SELECTING_EXISTING]: `只允许选择现有对话`,
  [k.ALLOW_BOTH_SELECTING_AND_CREAT]: `允许同时选择和创建`,
  [k.ALLOW_MULTIPLE]: `允许多个`,
  [k.ALLOW_ARCHIVED_CONVERSATIONS]: `允许已归档的对话`,
  [k.SHOW_FIELD_NAMES_IN_PREVIEW]: `在预览中显示字段名称`,
  [k.SHOW_STATUS_DUE_DATE]: `显示状态、截止日期`,
  [k.AUTO_FILL_RELATED_CONVERSATION]: `自动填充相关对话`,
  [k.SUPRESS_TITLE_HYPERLINK_TO_THE]: `取消标题到记录的超链接`,
  [k.SORTBY]: `排序方式：`,
  [k.CREATED_DATE]: `创建日期`,
  [k.ADDED_DATE]: `添加日期`,
  [k.SELECT_EXISTING_BY]: `通过以下方式选择现有`,
  [k.TITLE]: `标题`,
  [k.PLACEHOLDER]: `占位符`,
  [k.ALLOW_OFFICE_INTEGRATION]: `允许Office 365集成`,
  [k.YOU_MUST_SELECT_A_DEFAULT_FOLD]: `您必须在sharepoint/office365上选择一个默认文件夹来上传或创建文件。`,
  [k.AUTHENTICATE_AND_SELECT_FOLDER]: `认证并选择文件夹`,
  [k.VIEW]: `查看`,
  [k.FOLDER]: `文件夹`,
  [k.CONSUMPTION_OPTIONS]: `使用选项：`,
  [k.ALLOW_SINGLE]: `允许单个`,
  [k.PREVIEW_OPTIONS]: `预览选项：`,
  [k.SHOW_FULL_PREVIEW]: `显示完整预览`,
  [k.SORT_BY]: `排序方式：`,
  [k.DATE]: `日期`,
  [k.NAME]: `名称`,
  [k.DEFAULT_FILE]: `默认文件：`,
  [k.SUPPRESS_NOTIFICATIONS_ON_DEFA]: `抑制默认值的通知`,
  [k.FILE_UPLOAD_OPTIONS]: `文件上传选项：`,
  [k.UPLOAD_FROM_COMPUTER]: `从计算机上传`,
  [k.OFFICE_ONEDRIVE_SHAREPOI]: `Office 365 OneDrive / Sharepoint`,
  [k.FOLDER_PATH]: `文件夹路径`,
  [k.THE_CREATED_FILE_CAN_BE_EDITED]: `创建的文件可以由聊天室成员编辑`,
  [k.ADD_A_FORM]: `+ 添加表单`,
  [k.AUTO_FILL_RELATED_CONVERSATION1]: `自动填充相关对话`,
  [k.SHOW_COMPRESSED_PREVIEW]: `显示压缩预览`,
  [k.SHOW_STATUS_OWNER_AND_DUE_DAT]: `显示状态、所有者和截止日期`,
  [k.SUPPRESS_TITLE_HYPERLINK_TO_TH]: `取消标题到记录的超链接`,
  [k.LINKED_FIELD_RELATION]: `链接字段关系：`,
  [k.CHILD1]: `子级`,
  [k.PARENT2]: `父级`,
  [k.CHILD2]: `子级`,
  [k.OTHER_OPTIONS]: `其他选项：`,
  [k.ALLOW_ONLY_SELECTING]: `仅允许选择`,
  [k.ALLOW_SELECTING_AND_CREATING]: `允许选择和创建`,
  [k.ALLOW_ONLY_CREATING]: `仅允许创建`,
  [k.ONLY_SHOW_LINKED_FIELDS]: `仅显示链接字段`,
  [k.REVISIONS]: `修订版本：`,
  [k.ALLOW_MANUAL_REVISION_LINKING]: `允许手动修订版本链接，即使`,
  [k.THERE_ARE_NO_REVISIONS]: `没有修订版本`,
  [k.CREATED]: `已创建`,
  [k.MAX]: `最大值`,
  [k.MIN]: `最小值`,
  [k.MAX_VALUE_SHOULD_BE_MORE_THAN]: `最大值应大于最小值。`,
  [k.STEP]: `步长`,
  [k.MINIMUM_PLACES_TO_DISPLAY_AFTE]: `小数点后显示的最小位数（即使用户输入的位数少于指定值，也显示尾随零）`,
  [k.IF_THE_USER_ENTERS_MORE_DIGITS]: `如果用户在小数点后输入的位数多于上面指定的位数：`,
  [k.DON_T_ROUND_OFF_OR_TRUNCATE]: `不要四舍五入或截断`,
  [k.ROUND_OFF_WHEN_DISPLAYING_BUT]: `显示时四舍五入，但存储所有输入的数字`,
  [k.DEFAULT_VALUE]: `默认值`,
  [k.SUPPRESS_NOTIFICATIONS_FOR_DEF]: `抑制默认值的通知`,
  [k.TYPE1]: `类型`,
  [k.UNIFIZEPDF]: `unifizePdf`,
  [k.UNIFIZE_US]: `unifize.us`,
  [k.DELETED_FIELD1]: `（已删除字段）！`,
  [k.CHECKLIST_FIELD_WHERE_NATIVE_F]: `原生文件所在的检查表字段`,
  [k.UPLOAD_TEMPLATE]: `上传模板`,
  [k.DOWNLOAD1]: `下载`,
  [k.FETCHING]: `获取中`,
  [k.UPLOAD_TEMPLATE1]: `上传模板`,
  [k.CLICK_ON_STITCH_TO_CREATE_A_P]: `（点击缝合创建PDF）`,
  [k.STITCH]: `+ 缝合`,
  [k.BUTTON_TEXT_OPTIONAL]: `按钮文本（可选）`,
  [k.NAME_OF_SAVED_REPORTS_OPTIONA]: `已保存报告的名称（可选）`,
  [k.PREVIEW_OPTIONS1]: `预览选项`,
  [k.UPLOAD_TO_ANOTHER_FILE_FIELD]: `上传到另一个文件字段：`,
  [k.DON_T_ATTACH_FILE_TO_CHECKLIST]: `不要将文件附加到检查表`,
  [k.ATTACH_LATEST_VERSION_ONLY]: `仅附加最新版本`,
  [k.ATTACH_ALL_VERSIONS]: `附加所有版本`,
  [k.SORT_BY1]: `排序方式`,
  [k.DATE_ADDED]: `添加日期`,
  [k.SEARCH_USERS]: `搜索用户`,
  [k.OPEN_BY_DEFAULT_FOR]: `默认为以下人员打开`,
  [k.OPTIONS]: `选项`,
  [k.ADD_OPTIONS_DYNAMICALLY]: `动态添加选项`,
  [k.DEFAULT1]: `默认`,
  [k.ALPHABETICAL]: `按字母顺序`,
  [k.PENDINGVALUE]: `待处理值`,
  [k.COMPLETEDVALUE]: `已完成值`,
  [k.SELECT_A_STATUS]: `选择状态`,
  [k.TRIANGLEDOWN]: `向下三角形`,
  [k.MULTILINE]: `多行`,
  [k.USER2]: `用户`,
  [k.MULTIPLE]: `多个`,
  [k.SELECT_A_FORM_TO_ADD_CONDITION]: `选择一个表单以添加条件`,
  [k.UNSTYLED]: `无样式`,
  [k.D_AUTO_LAYOUT]: `2D自动布局`,
  [k.MAXIMUM_FIELD_WIDTH_SMALLER_W]: `最大字段宽度（较小的宽度允许一行显示更多字段）`,
  [k.FORCE_START_ON_A_NEW_ROW]: `强制在新行开始`,
  [k.X]: `1倍`,
  [k.X1]: `2倍`,
  [k.X2]: `3倍`,
  [k.MAX_WIDTH]: `最大宽度`,
  [k.CONDITIONS]: `条件`,
  [k.PROMPTS]: `提示`,
  [k.LAYOUT]: `布局`,
  [k.FORM_CONDITIONS]: `表单条件`,
  [k.CANCEL_CHANGES]: `取消更改`,
  [k.UPDATE_FIELD_SETTINGS]: `更新字段设置`,
  [k.RESOLVE_AND_UPDATE]: `解决并更新`,
  [k.ME1]: `我`,
  [k.ADDFIELDS]: `添加字段`,
  [k.HOLLOWPLUSCIRCLE]: `空心加号圆圈`,
  [k.ADD_FIELDS]: `添加字段`,
  [k.THE_CHECKLIST_HAS_NOT_BEEN_CON]: `检查表尚未配置。`,
  [k.USE_THE_ADD_FIELD_BUTTON_TO_ST]: `使用添加字段按钮开始创建或上传Excel表格。`,
  [k.CHECKLIST_LAYOUT_DEFAULTS]: `检查表布局默认值`,
  [k.CHECKLIST_OPEN_BY_DEFAULT]: `默认打开检查表？`,
  [k.WEB_APP]: `Web应用`,
  [k.UNIFIZE_LITE_ON_WEB]: `网页版Unifize精简版`,
  [k.UNIFIZE_LITE_ON_MOBILE_NAVIGA]: `移动版Unifize精简版（打开对话时导航到检查表）`,
  [k.DEFAULT_CHECKLIST_WIDTH_ON_UNI]: `Unifize网页应用默认检查表宽度`,
  [k.SINGLE_COLUMN]: `单列`,
  [k.DOUBLE_COLUMN]: `双列`,
  [k.TRIPLE_COLUMN]: `三列`,
  [k.SPLIT_AVAILABLE_SCREEN_SPACE_I]: `将可用屏幕空间分为50%对话和50%检查表`,
  [k.ONLY_THE_CONTENTS_OF_THE_CONVE1]: `只有对话的内容会被隐藏，其他数据如通知对所有人可见`,
  [k.CONVERSATIONS_WILL_BE_VISIBLE1]: `对话只对参与者、管理员和白名单人员可见`,
  [k.PRIVACY_SETTINGS_DON_T_APPLY_T]: `隐私设置不适用于白名单人员`,
  [k.MAKE_PRIVATE1]: `设为私密`,
  [k.ONLY_PARTICIAPNTS_CAN_ACCESS_T]: `只有参与者可以访问这些对话`,
  [k.PRIVATE_CONVERSATIONS_CAN_ONLY]: `私密对话只能由流程所有者编辑`,
  [k.AUTO_REMIND_IN]: `自动提醒于`,
  [k.ALLOW_PARTICIPANTS_TO_DISABLE]: `允许参与者禁用`,
  [k.REMINDER_MESSAGE]: `提醒消息`,
  [k.SELECT_VALUE]: `选择值`,
  [k.ADD_AUTO_REMINDER]: `添加自动提醒`,
  [k.DESCRIPTION]: `描述`,
  [k.PARTICIPANTS]: `参与者`,
  [k.OWNER]: `所有者`,
  [k.FORM_OWNERS]: `表单所有者`,
  [k.PROCESS_OWNERS]: `流程所有者`,
  [k.TAB]: `标签`,
  [k.NOTIFICATION_SETTINGS]: `通知设置`,
  [k.EXIT_PROCESS_EDITOR]: `退出流程编辑器`,
  [k.ENTER_A_TITLE_FOR_THIS_PROCESS]: `为此流程输入标题`,
  [k.SAVEPROCESSTEMPLATEBUTTON]: `保存流程模板按钮`,
  [k.DEFINE_NEW_PROCESS_TEMPLATE]: `定义新流程模板`,
  [k.CREATE_PROCESS]: `创建流程`,
  [k.SAVE_CHANGES]: `保存更改`,
  [k.EXPORT_FIELDS_JSON]: `导出字段JSON`,
  [k.SAVE_AND_GO_TO]: `保存并转到`,
  [k.TEAM]: `团队`,
  [k.STATUS]: `状态`,
  [k.DELETED_FIELDS]: `已删除字段`,
  [k.ADVANCED_PROCESS_SETTINGS]: `高级流程设置`,
  [k.DEFAULT_FORM_COLOUR]: `默认表单颜色`,
  [k.DETAILS]: `详情`,
  [k.EXIT_FORM_EDITOR]: `退出表单编辑器`,
  [k.CREATE_FORM]: `创建表单`,
  [k.REPORTS]: `报告`,
  [k.FORMS]: `表单`,
  [k._18]: `>`,
  [k.TO]: `至`,
  [k.FILTERS_APPLIED]: `已应用的过滤器：`,
  [k.SORTED_BY]: `排序方式：`,
  [k.CLEAR_ALL]: `清除全部`,
  [k.SHARE]: `分享`,
  [k.RESULTS]: `结果`,
  [k.SAVE_AS]: `另存为`,
  [k.ASCENDING]: `升序`,
  [k.DESCENDING]: `降序`,
  [k.TO_ARRANGE_DRAG_UP_OR_DOWN]: `上下拖动以排列`,
  [k.FILTER_NAME]: `过滤器名称`,
  [k.ORDER]: `顺序`,
  [k.PARAMETERS]: `参数`,
  [k.SORT_BY2]: `排序方式`,
  [k.FILTER_VALUES]: `过滤值`,
  [k.SELECT_DATE]: `选择日期`,
  [k.FILTER_BY]: `过滤依据`,
  [k.AFTER]: `之后`,
  [k.BEFORE]: `之前`,
  [k.FILTER]: `过滤`,
  [k.USERFILTER]: `用户过滤器`,
  [k.THERE_ARE_NO_FORMS_THAT_MATCHE]: `没有符合过滤条件的表单`,
  [k._19]: `_`,
  [k.DELETE_FORM]: `删除表单`,
  [k.FORM_NAME]: `表单名称`,
  [k.CREATED_AT]: `创建于`,
  [k.UPDATED_AT]: `更新于`,
  [k.CREATED_BY1]: `创建者`,
  [k.NEW]: `新建`,
  [k.MANAGE]: `管理`,
  [k.PROCESSES]: `流程`,
  [k.EDIT1]: `编辑`,
  [k.DESCRIPTION1]: `描述：`,
  [k.REPORT]: `报告：`,
  [k.CREATE_NEW_CHART]: `创建新图表`,
  [k.CHARTS_FOR_THIS_REPORT]: `此报告的图表`,
  [k.MULTIPLE_VALUE_CALCULATION]: `多值计算`,
  [k.IF_A_FIELD_CONTAINS_MULTIPLE_V]: `如果一个字段包含每个对话的多个值，请选择y轴总计代表什么`,
  [k.Y_AXIS_SHOWS_TOTAL_CONVERSATIO]: `y轴显示总对话计数（即相互之间的比例权重）`,
  [k.Y_AXIS_SHOWS_TOTAL_VALUE_COUNT]: `y轴显示总值计数（即每个值的权重相等）`,
  [k.PRIMARY_Y_AXIS_LABEL]: `主y轴标签`,
  [k.SECONDARY_Y_AXIS_LABEL]: `次y轴标签`,
  [k.CHART_TYPE]: `图表类型`,
  [k.PRIMARY_FIELD]: `主字段`,
  [k.PRIMARYRECORD]: `主记录`,
  [k.PRIMARY_RECORD]: `主记录`,
  [k.MULTIPLE_VALUES]: `多个值`,
  [k.ADD_COMPARISON]: `+ 添加比较`,
  [k.ADD_TRENDLINE]: `添加趋势线`,
  [k.SELECT_ABOVE_FIELDS_TO_ENABLE]: `选择上述字段以启用此功能`,
  [k.TRENDLINE_LABEL]: `趋势线标签`,
  [k.TRENDLINE_COLOR]: `趋势线颜色`,
  [k.HIDE1]: `隐藏`,
  [k.OF]: `的`,
  [k.SELECT_FIELD]: `选择字段`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DELET2]: `您确定要删除"`,
  [k._20]: `"`,
  [k.GROUP_BY]: `分组依据`,
  [k.ADD_TREND_LINE]: `添加趋势线`,
  [k.PERCENT]: `百分比`,
  [k.PPM]: `PPM`,
  [k.SHOW_AS_PERCENT_OF_OTHER_VALUE]: `显示为其他值的百分比`,
  [k.SERIES1]: `系列#`,
  [k.SUMMARY_TYPE]: `汇总类型`,
  [k.X_AXIS]: `x轴`,
  [k.UNTITLED_CHART]: `无标题图表`,
  [k.ADVANCED_SETTINGS]: `高级设置`,
  [k.PLEASE_FILL_MANDATORY_FIELDS]: `请填写必填字段`,
  [k.SUBMIT]: `提交`,
  [k.CHART1]: `图表`,
  [k.SELECT_A_COMPARISON_CHART]: `选择比较图表`,
  [k.FORM1]: `（表单：`,
  [k.FIELD2]: `）（字段：`,
  [k.COMMONCHECKLIST]: `通用检查表`,
  [k.MULTIPLE_VALUE_FIELD]: `多值字段`,
  [k.STATUS1]: `状态`,
  [k.CREATED1]: `已创建`,
  [k.COMPLETED]: `已完成`,
  [k.ADD_COLUMN]: `添加列`,
  [k.SELECT_FORM1]: `选择表单`,
  [k.THE_COUNT_WILL_REPRESENT_THE_T]: `计数将代表此表单所有实例的总数`,
  [k.X_AXIS1]: `（x轴）`,
  [k.PRIMARY_FIELDS_ARE_THE_MAIN_UN]: `主字段是图表的主要基础数据`,
  [k.GROUP_BY_FIELD]: `分组字段`,
  [k.OPTIONAL]: `（可选）`,
  [k.GROUP_BY_FIELD_TYPE_IS_APPLIED]: `分组字段类型应用于主字段以创建图表`,
  [k.ADVANCED_SETTINGS1]: `高级设置`,
  [k.IF_A_FIELD_CONTAINS_MULTIPLE_V1]: `如果一个字段包含每个对话的多个值，请选择y轴总计代表什么`,
  [k.Y_AXIS_LABEL]: `y轴标签`,
  [k.SAVE_CHANGES1]: `保存更改`,
  [k.CREATE_CHART]: `创建图表`,
  [k.LABEL_FOR_Y_AXIS_OF_THE_CHART]: `图表y轴的标签`,
  [k.IF_A_FIELD_CONTAINS_MULTIPLE_V2]: `如果一个字段包含每个对话的多个值，请选择y轴总计代表什么`,
  [k.CREATE_AND_SAVE]: `创建并保存`,
  [k.Y_AXIS_SHOWS_TOTAL_CONVERSATIO1]: `y轴显示总对话计数（即每个值的比例权重）`,
  [k.ENTER_THE_TITLE_OF_YOUR_CHART]: `输入您的图表标题`,
  [k.NUMERIC_CHECKLIST_FIELD]: `数值检查表字段`,
  [k.THIS_FIELD_WILL_CONTAIN_THE_NU]: `此字段将包含要添加的数值数据，如$值、总时间或单位`,
  [k.IF_A_FIELD_CONTAINS_MULTPLE_VA]: `如果一个字段包含每个对话的多个值，请选择y轴总计代表什么`,
  [k.DAILY]: `每日`,
  [k.WEEKLY]: `每周`,
  [k.MONTHLY]: `每月`,
  [k.YEARLY]: `每年`,
  [k.MMM_DD_YYYY1]: `MMM DD YYYY`,
  [k.LAST]: `最后`,
  [k.TIME_INTERVAL_FREQUENCY]: `时间间隔（频率）`,
  [k.THE_INTERVAL_AT_WHICH_THE_NUME]: `上面选择的数值重复的间隔`,
  [k.TIME_PERIOD]: `时间段`,
  [k.SELECT_A_TIME_FRAME_OR_A_DATE]: `为图表选择时间范围或日期范围`,
  [k.COLUMN1]: `列`,
  [k.SHOW_A_COLUMN_FOR_EACH_OF_THE]: `为以下每一项显示一列：`,
  [k.FIELDS_OF_THE_CHART]: `图表的字段`,
  [k.CHART_TITLE]: `图表标题`,
  [k.WHAT_DOES_THIS_CHART_REPRESENT]: `这个图表代表什么？`,
  [k.SELECT_A_CHART_FOR]: `为以下选择图表`,
  [k.SAVE_AS1]: `另存为`,
  [k.DO_YOU_WANT_TO_DELETE]: `您想要删除"`,
  [k.ENTER_REPORT_TITLE]: `输入报告标题`,
  [k.SAVE_AS_REPORT]: `另存为报告`,
  [k.EDIT_REPORT_TITLE]: `编辑报告标题`,
  [k.EDIT2]: `编辑`,
  [k.REPORT_NAME]: `报告名称`,
  [k.STRING1]: `字符串`,
  [k.APPLY_BULK_CHANGES]: `应用批量更改`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_APPLY]: `您确定要对多个对话应用更改吗？`,
  [k.REPEAT_LAST_ACTION_TO_ALL]: `对所有重复上次操作`,
  [k.REPLACE_ALL]: `全部替换`,
  [k.ALL]: `全部`,
  [k.RECORDS]: `记录`,
  [k.DATE1]: `日期`,
  [k.CUSTOMIZE_VIEW]: `自定义视图`,
  [k.DOWNLOAD_AS_CSV]: `下载为CSV`,
  [k.DOWNLOAD_AS_XLSX]: `下载为XLSX`,
  [k.DOWNLOAD_WITH_FILES]: `下载及文件`,
  [k.DOWNLOAD_AS_JSON_BETA]: `下载为JSON（测试版）`,
  [k.YOU_WILL_RECEIVE_AN_EMAIL_ON]: `您将收到一封电子邮件，地址为`,
  [k.ONCE_THE_IMPORT_IS_DON]: `导入完成后。`,
  [k.SUBMIT1]: `提交`,
  [k.UPLOAD_CSV]: `上传CSV`,
  [k.SELECT_CSV_FILE]: `选择CSV文件`,
  [k.LOADING_RESULTS]: `加载结果`,
  [k.SHOW_ALL_REVISIONS]: `显示所有修订版本`,
  [k.NEW1]: `新建`,
  [k.CUSTOMIZE_TABLE_VIEW]: `自定义表格视图`,
  [k.COLUMN_TITLE]: `列标题`,
  [k.RESET]: `重置`,
  [k.APPLY]: `应用`,
  [k.SAVEAS]: `另存为`,
  [k.EMBEDDED_FIELDS1]: `嵌入字段`,
  [k.EXPANSION]: `展开`,
  [k.FILTER_BY_VALUE]: `按值过滤`,
  [k.MONTHS]: `月`,
  [k.YEARS]: `年`,
  [k.DATE_RANGE]: `日期范围`,
  [k.FORM2]: `表单`,
  [k.EXPAND]: `展开`,
  [k.PRIORITY]: `优先级`,
  [k.LOW]: `低`,
  [k.NORMAL1]: `正常`,
  [k.HIGH]: `高`,
  [k.CRITICAL]: `关键`,
  [k.SELECT_ALL1]: `全选`,
  [k.SELECT_NONE]: `全不选`,
  [k.MAPPED_TO]: `映射到`,
  [k.PENDING]: `待处理`,
  [k.COMPLETE]: `完成`,
  [k.INCLUDE]: `包括`,
  [k.ARCHIVED]: `已归档`,
  [k.CANCELLED]: `已取消`,
  [k.THERE_ARE_NO_PROCESSES_THAT_MA]: `没有符合这些过滤条件的流程`,
  [k.RESIZING]: `调整大小"`,
  [k._24]: "",
  [k.NO_VALUE]: `无值`,
  [k.CURRENTCHATROOMTITLE]: `当前聊天室标题`,
  [k.C]: `C`,
  [k.CARETUP]: `向上插入符号`,
  [k.MAKE_AS_CURRENT]: `设为当前`,
  [k.ARRAY]: `数组`,
  [k.EDITPENCIL]: `编辑铅笔`,
  [k.NO_DESCRIPTION]: `无描述`,
  [k.DISABLED1]: `已禁用`,
  [k.PARENT3]: `父级`,
  [k.NO_PARENT]: `无父级`,
  [k.UPDATE_STATUS]: `更新状态：`,
  [k.CARETDOWN]: `向下插入符号`,
  [k.UNTITLED_CONVERSATION]: `无标题对话`,
  [k.PAGE]: `页`,
  [k.GO_TO_PAGE]: `| 转到页面：`,
  [k.BACK_TO_REPORT]: `返回报告`,
  [k.CREATE_ANOTHER_CHART]: `创建另一个图表`,
  [k.OWNER1]: `所有者`,
  [k.DUEDATE]: `截止日期`,
  [k._28]: `↑`,
  [k._29]: `↓`,
  [k.PROCESS_NAME]: `流程名称`,
  [k.ACTIVE_INSTANCES]: `活动记录`,
  [k.TOTAL_INSTANCES]: `总记录`,
  [k.CREATED_BY2]: `创建者`,
  [k.EDIT_PROCESS]: `编辑流程`,
  [k.DELETE_PROCESS]: `删除流程`,
  [k.DRAFT]: `草稿`,
  [k.DELETE_PROCESS1]: `删除流程`,
  [k.ALL_ASSOCIATED_CONVERSATIONS]: `？所有关联的记录将被取消。`,
  [k.FETCHING_USER_AND_ORG_DETAILS]: `获取用户和组织详情`,
  [k.INTEGRATION_NOT_FOUND]: `未找到集成！`,
  [k.IS_REQUESTING_PERM]: `正在请求访问您的Unifize账户的权限，网址为`,
  [k.WHAT_CAN]: `什么可以`,
  [k.DO]: `做？`,
  [k.ALLOW]: `允许`,
  [k.DENY]: `拒绝`,
  [k.HTTPS_CDN_BFLDR_COM_H_O_W]: `https://cdn.bfldr.com/5H442O3W/at/pl546j-7le8zk-6gwiyo/Slack_Mark.svg?auto=webp&format=svg`,
  [k.SLACK]: `Slack`,
  [k.MICROSOFT]: `Microsoft 365`,
  [k.MICROSOFT_ADMIN]: `Microsoft 365管理员`,
  [k.CREATE_CONVERSATIONS_ON_UNIFIZ]: `代表您在Unifize上创建对话。`,
  [k.FORWARD_MESSAGES_TO_UNIFIZE_ON]: `代表您将消息转发到Unifize。`,
  [k.NETWORK_ERROR_LOOKS_LIKE_YOU]: `网络错误！看起来您已离线:(`,
  [k.CLICK_HERE_TO_TRY_AGAIN]: `点击此处重试`,
  [k.EMAIL1]: `邮箱`,
  [k.CREATING]: `正在创建`,
  [k.ORG1]: `组织...`,
  [k.YOUR_ORG_IS_READY_YOU_WILL_BE]: `您的组织已准备就绪。您将很快被重定向。`,
  [k.ERROR_CREATING_YOUR_ORG]: `创建您的组织时出错`,
  [k.SOMEONE_FROM_UNIFIZE_WILL_SOON]: `Unifize的某人很快会联系您。`,
  [k.ORG_NAME]: `组织名称`,
  [k.EMAIL_ADDRESS]: `电子邮件地址`,
  [k.AT_LEAST_CHARACTERS]: `至少8个字符`,
  [k.A_MIXTURE_OF_LETTERS_AND_NUMBE]: `字母和数字的混合。`,
  [k.INCLUSION_OF_AT_LEAST_ONE_UPPE]: `至少包含一个大写字母`,
  [k.CONFIRM_PASSWORD]: `确认密码`,
  [k.FIRST_NAME]: `名字`,
  [k.LAST_NAME]: `姓氏`,
  [k.PLEASE_VERIFY_YOUR_EMAIL_ADDRE]: `请验证您的电子邮件地址...`,
  [k.CLICK_ON_THE_LINK_WE_SENT_TO]: `点击我们发送到`,
  [k.TO_CREATE_YOUR_ORG]: `的链接来创建您的组织。`,
  [k.DIDN_T_RECEIVE_AN_EMAIL]: `没有收到电子邮件？`,
  [k.RESEND_EMAIL]: `重新发送电子邮件`,
  [k.STEP_OF]: `步骤1/3`,
  [k.SIGN_UP]: `注册`,
  [k.SPEED_UP_YOUR_PROCESSES_BY_X]: `在30天内将您的流程速度提高3倍`,
  [k.STEP_OF1]: `步骤2/3`,
  [k.CREATE_ACCOUNT]: `创建账户`,
  [k.SIGN_IN]: `登录`,
  [k.YOU_HAVE_ALREADY_USED_THIS_EMA]: `您已经使用此电子邮件创建了账户。`,
  [k.STEP_OF2]: `步骤3/3`,
  [k.SIGN_OUT]: `退出`,
  [k.LAST_STEP]: `最后一步`,
  [k.INVITE_YOUR_COLLABORATORS]: `，邀请您的合作者`,
  [k.NO_MORE_SILOS_INVITE_UP_TO]: `不再有孤岛。现在邀请最多4位同事。您可以稍后邀请更多人。`,
  [k.STAGE_INFO_HEADER]: `阶段信息标题：`,
  [k.STAGE]: `阶段：`,
  [k.THIS_LINK_IS_NOT_VALID]: `此链接无效`,
  [k.NEXT]: `下一步`,
  [k.BY_SIGNING_UP_I_AGREE_TO_THE]: `通过注册，我同意Unifize隐私政策和服务条款。`,
  [k.CENTER_SECTION]: `中心部分`,
  [k.RIGHT_SECTION]: `右侧部分`,
  [k.ADD_SECTION]: `+ 添加部分`,
  [k.SELECT_FROM_EXISTING_TILES]: `从现有磁贴中选择`,
  [k.CREATE_NEW_TILE]: `创建新磁贴`,
  [k.CONVERSATIONS]: `对话`,
  [k.MY_CONVERSATION_CHART]: `我的对话图表`,
  [k.MY_RECORD_CHART]: `我的记录图`,
  [k.START_NEW]: `开始新建`,
  [k.PIN_A_DASHBOARD_CHART]: `固定仪表板图表`,
  [k.NAME2]: `名称`,
  [k.DO_YOU_WANT_TO_DELETE1]: `您想要删除`,
  [k.ADD_NEW_TILE]: `+ 添加新磁贴`,
  [k.SUB_TITLE]: `副标题`,
  [k.FILTERS]: `过滤器`,
  [k.SELECT_AT_LEAST_ONE]: `（至少选择一个）`,
  [k.UNREAD]: `未读`,
  [k.I_OWN]: `我拥有的`,
  [k.BLUECROSS]: `蓝色叉号`,
  [k.EVERYONE]: `所有人`,
  [k.EVERYONE1]: `所有人`,
  [k.BUTTON_TEXT]: `按钮文本`,
  [k.WHEN_EMPTY]: `当为空时`,
  [k.TILE_COLOR]: `磁贴颜色`,
  [k.SELECT_A_CHART]: `选择图表`,
  [k.DON_T_SHOW_TILE]: `不显示磁贴`,
  [k.SHOW_A_MESSAGE]: `显示消息`,
  [k.EXCLUDE_PROCESS]: `排除流程`,
  [k.INCLUDE_PROCESS]: `包含流程`,
  [k.COLUMNS]: `列`,
  [k.OVERDUE]: `逾期`,
  [k.TILE_TYPE_CONVERSATIONS]: `磁贴类型：对话`,
  [k.TILE_TYPE_MY_CONVERSATION_CHA]: `磁贴类型：我的对话图表`,
  [k.TILE_TYPE_MY_RECORD_CHART]: `磁贴类型：我的记录图`,
  [k.TILE_TYPE_START_NEW]: `磁贴类型：开始新建`,
  [k.TILE_TYPE_DASHBOARD_CHART]: `磁贴类型：仪表板图表`,
  [k.SECTION1]: `部分：`,
  [k.ADD_USER_SEGMENT]: `+ 添加用户分组`,
  [k.AND_USER]: `与用户`,
  [k.SHOW_TO]: `显示给`,
  [k.AND_USER1]: `+ 与用户`,
  [k.AGE1]: `时长`,
  [k.SELECT_TIMEPERIOD]: `选择时间段`,
  [k.SELECTED]: `已选择`,
  [k.SELECT_GROUP]: `选择群组`,
  [k.SELECT_VALUES]: `选择值`,
  [k.CREATE_NEW_USER_SEGMENT]: `创建新用户分组`,
  [k.OTHERS1]: `其他人`,
  [k.ENABLE_HOME_SCREEN]: `启用主屏幕`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DISAB]: `您确定要禁用`,
  [k.INTEGRATION]: `集成？`,
  [k.DISABLE]: `禁用`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DISCO]: `您确定要断开连接`,
  [k.INTEGRATION_YOU_COULD]: `集成？您可能会
            失去通过其访问或托管的数据`,
  [k.YOU_CANNOT_UNDO_THIS_ACTION_C]: `您无法撤销此操作。请考虑改为禁用此集成。`,
  [k.DISCONNECT]: `断开连接`,
  [k.HEADING]: `标题`,
  [k.INTEGRATION1]: `集成`,
  [k.INTEGRATE]: `集成`,
  [k.GLOBAL_OR_PRIVILEGED_ADMINIST]: `*仅全局或特权管理员`,
  [k.NO_APPS_FOUND]: `未找到应用`,
  [k.ORG_SETTINGS]: `组织设置`,
  [k.HOME_SCREEN1]: `主屏幕`,
  [k.ORG_DETAILS1]: `组织详情`,
  [k.ROLE_MANAGEMENT1]: `角色管理`,
  [k.APPS]: `应用`,
  [k.DELETE_ROLE]: `删除角色`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DELET3]: `您确定要删除此角色吗？`,
  [k.DELETE_ORG_DOMAIN]: `删除组织域名`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DELET4]: `您确定要删除此组织域名吗？`,
  [k.ORG_DOMAIN]: `组织域名`,
  [k.EMAIL_PREFIX]: `电子邮件前缀`,
  [k.ALLOW_CLONING]: `允许克隆`,
  [k.SYSTEM_PROMPT]: `系统指令`,
  [k.SYSTEM_PROMPT_DESCRIPTION]: `此提示词控制整个应用中 AI 的行为`,
  [k.ORG_DESCRIPTION]: `组织描述`,
  [k.ORG_DESCRIBER_VIDEO_PASTE_IFR]: `组织描述视频（粘贴iframe代码）`,
  [k.ADD_USER]: `添加用户`,
  [k.MEMBERS1]: `成员`,
  [k.ADD_USERS]: `+ 添加用户`,
  [k.ADD_A_NEW_ROLE]: `+ 添加新角色`,
  [k.FUNCTIONALITY]: `功能`,
  [k.SERVICE_PROVIDER_ENTITY_ID]: `服务提供商实体ID`,
  [k.AUTHORIZATION_CALLBACK_URL]: `授权回调URL`,
  [k.HUGE_PARAGRAPH_HERE]: `（此处为大段文字）`,
  [k.YES_LOGOUT_ALL_USERS]: `是，注销所有用户`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_DISAB1]: `您确定要禁用SSO吗？`,
  [k.ENTER_NEW_PASSWORD]: `输入新密码`,
  [k.CONFIRM_NEW_PASSWORD]: `确认新密码`,
  [k.DISABLE_SSO]: `禁用SSO`,
  [k.DOMAIN1]: `域名`,
  [k._31]: `*`,
  [k.ENTITY_ID]: `实体ID`,
  [k.SSO_URL]: `SSO URL`,
  [k.CERTIFICATE]: `证书`,
  [k.ADD_CERTIFICATE]: `添加证书`,
  [k.MUST_START_WITH_BEGIN_CE]: `必须以'-----BEGIN CERTIFICATE-----'开头，以'-----END CERTIFICATE-----'结尾`,
  [k.PAGE_NOT_FOUND]: `404 页面未找到`,
  [k.WELCOME_BACK1]: `欢迎回来`,
  [k._32]: `！`,
  [k.LOG_IN]: `登录`,
  [k.TO_USE_THE_FULL]: `使用完整
                    版本的应用`,
  [k.LOG_IN1]: `登录`,
  [k.SIGN_UP1]: `注册`,
  [k.DRIVE_PROCESS_THROUGH_CONVERSA]: `通过对话推动流程`,
  [k.UNIFIZE_INCREASES_YOUR_TEAM]: `Unifize通过将团队`,
  [k.S_EFFICIENCY_BY_UP_TO_X_BY]: `的对话连接到流程目标，将效率提高10倍。`,
  [k.SIGN_UP_FAILED]: `注册失败！`,
  [k.CLICK_HERE_TO]: `点击此处`,
  [k.RESEND1]: `重新发送`,
  [k.VERIFICATION_EMAIL_SENT]: `验证邮件已发送`,
  [k.AN_EMAIL_HAS_BEEN_SENT_TO]: `邮件已发送至`,
  [k.PLEASE_OPEN_YOUR_EMA]: `。请打开
          您的邮箱并点击链接以在Unifize上完成设置。`,
  [k.OR]: `或`,
  [k.CHATROOM_HEADER]: `聊天室标题`,
  [k.CLICK_HERE_TO_SIGN_UP_OR_LOG_I]: `点击此处注册或登录。`,
  [k.HEADER]: `标题`,
  [k.INPUT]: `输入`,
  [k.YOU_NEED_TO_LOG_IN_TO_DO_THAT]: `您需要登录才能执行该操作`,
  [k.HISTORY]: `历史`,
  [k.PANEL]: `面板`,
  [k.PLUSCIRCLE]: `加号圆圈`,
  [k.FILE]: `文件`,
  [k.MANAGE_FILE_VIEW]: `管理文件视图`,
  [k.CREATEPROCESSTEMPLATE]: `创建流程模板`,
  [k.REMOVECIRCLE]: `移除圆圈`,
  [k.CLEAR_ALL1]: `清除全部`,
  [k.OPTION_NOT_FOUND]: `未找到选项`,
  [k.ADD_NEW_OPTION]: `添加新选项`,
  [k.NEW_OPTION]: `新选项`,
  [k.EMAIL_NOTIFICATIONS]: `电子邮件通知`,
  [k.SELECT_YOUR_PREFERED_NOTIFICAT]: `选择您的首选通知设置`,
  [k.NOTIFICATIONS]: `通知`,
  [k.EVERYTHING]: `全部：`,
  [k.ALL_UPDATES_AND_MESSAGES]: `所有更新和消息`,
  [k.FOR_CONVERSATIONS_YOU_ARE_A_PA]: `对于您参与的对话`,
  [k.YOU_WILL_BE_NOTI]: `，您将通过
              电子邮件收到所有这些更新的通知：`,
  [k.ALL_COMMENTS]: `所有评论`,
  [k.AND_MESSAGES]: `和消息`,
  [k.YOU_VE_BEEN_ADDED]: `您已被添加`,
  [k.TO_A_CONVERSATION]: `到对话中`,
  [k.ALL_STATUS_UPDATES]: `所有状态更新，`,
  [k.INCLUDING_WHEN_CONVERSATIONS]: `包括对话
                完成时`,
  [k.WHEN_THE_CONVERSATION_IS]: `当对话`,
  [k.OVERDUE1]: `逾期`,
  [k.AND_OTHER]: `和其他`,
  [k.ANY_OWNER_CHANGE]: `任何所有者更改`,
  [k.OR_ASSIGNMENT]: `或分配`,
  [k.WHEN_YOU_VE_BEEN]: `当您被`,
  [k.MENTIONED]: `@提及`,
  [k.IN_A_CONVERSATION]: `在对话中`,
  [k.IMPORTANT]: `重要：`,
  [k.STATUS_UPDATES_REMINDERS_AND]: `状态更新、提醒和@提及`,
  [k.FOR_CONVERSATIONS_YOU_ARE_A_PA1]: `对于您参与的对话，`,
  [k.YOU_WILL_BE_NOTIFI]: `您将通过
              电子邮件收到所有这些更新的通知：`,
  [k.ALL_STATUS_UPDATES1]: `所有状态更新`,
  [k.INCLUDING_WHEN_CONVERSATIONS1]: `，包括对话
                完成时`,
  [k.AND_OTHER_REMIND]: `和其他
                提醒`,
  [k.CRITICAL1]: `关键：`,
  [k.CRITICAL_UPDATES_AND_MENTIONS]: `关键更新和@提及`,
  [k.YOU_VE_BEEN_ASSIGNED_AS_THE_OW]: `您已被指定为所有者`,
  [k.OF_A_CONVERSATIO]: `对
                对话`,
  [k.YOU_VE_BEEN]: `您已被`,
  [k.NOTHING_NOT_RECOMMENDED]: `无（不推荐）`,
  [k.YOU_WILL_NOT_BE_NOTIFIED_VIA_E]: `您将不会通过电子邮件收到通知。这可能导致您错过参与的重要对话。`,
  [k.SORT]: `排序`,
  [k.FILTER_VALUES1]: `过滤值`,
  [k.SEARCH1]: `搜索`,
  [k.BLUETICK]: `蓝色勾号`,
  [k.CREATE_NEW_STATUS]: `+ 创建新状态`,
  [k.ENTER_STATUS_TITLE]: `输入状态标题`,
  [k.ACTIVERADIOBUTTON]: `活动单选按钮`,
  [k.DEFAULTRADIOBUTTON]: `默认单选按钮`,
  [k.MAP_TO_PENDING]: `映射到待处理`,
  [k.MAP_TO_COMPLETE]: `映射到完成`,
  [k.DISABLE_UNTIL_APPROVED]: `禁用直到批准`,
  [k.DELETETRASH]: `删除垃圾`,
  [k.CIRCLEDOWN]: `向下圆圈`,
  [k.HIDE_UNTIL_CONDITION_MET]: `隐藏直到满足条件`,
  [k.ENABLE_UNTIL_CONDITION_MET]: `启用直到满足条件`,
  [k.STATUS_TYPE]: `状态类型`,
  [k.ARCHIVE_BEHAVIOR]: `归档行为`,
  [k.IGNORE_ARCHIVING]: `忽略归档`,
  [k.AUTO_UNARCHIVE]: `自动取消归档`,
  [k.STATUS_SETTINGS]: `状态设置`,
  [k.YOU_NEED_TO_HAVE_AT_LEAST_ONE]: `您需要至少有一个状态映射到`,
  [k.PENDING2]: `待处理`,
  [k.AND]: `和`,
  [k.COMPLETED1]: `已完成`,
  [k.EACH]: `各一个。`,
  [k.OK]: `确定`,
  [k._34]: `✕`,
  [k.UPDATE_HAS_BEEN_RELEASED]: `更新已发布`,
  [k.THERE_IS_A_NEW_VERSION_OF_THE]: `应用有新版本可用，点击刷新查看。`,
  [k.ACCESS_DENIED]: `访问被拒绝！！`,
  [k.CONTACT_US]: `联系我们`,
  [k.LOOKS_LIKE_YOUR_EMAIL_IS_NOT_V]: `您的邮箱似乎未经验证`,
  [k.AN_EMAIL_HAS_BEEN_SENT_TO_YOUR]: `邮件已发送到您的账户。请打开您的邮箱并点击链接以在Unifize上完成设置。`,
  [k.STILL_HAVING_TROUBLES]: `仍然有问题？`,
  [k.FORGOT_YOUR_PASSWORD]: `忘记密码？`,
  [k.ENTER_THE_EMAIL_ADDRESS_YOU_US]: `输入您用于此账户的电子邮件地址。您将在几分钟内收到一封包含重置密码链接的邮件。`,
  [k.SEND_LINK]: `发送链接`,
  [k.PASSWORD1]: `密码`,
  [k.LOADING1]: `加载中`,
  [k.LOADING_CONVERSATIONS_FOR]: `正在加载对话，用于`,
  [k.UNABLE_TO_LOGIN]: `无法登录 -`,
  [k.CONTINUE_IN_APP]: `在应用中继续`,
  [k.HEY_THERE_LOOKS_LIKE_YOU_RE_T]: `嘿！看起来您正在尝试从移动设备登录。`,
  [k.CONTINUE_WITH_UNIFIZE_MOBILE_A]: `继续使用Unifize移动应用`,
  [k.ABOUT_US]: `关于我们`,
  [k.RESET_YOUR_PASSWORD]: `重置您的密码`,
  [k.YOU_HAVE_CLICKED_ON_A_PASSWORD]: `您点击了以下账户的密码重置链接：`,
  [k.ENTER_A_NEW_PASSWORD]: `输入新密码`,
  [k.RESET_MY_PASSWORD]: `重置我的密码`,
  [k.PASSWORD_RESET]: `密码重置`,
  [k.RESET_LINK_SENT]: `重置链接已发送`,
  [k.RESET_INSTRUCTIONS_HAVE_BEEN_S]: `重置说明已发送至`,
  [k.YOU_WILL_RECEIVE]: `。您
              将在5分钟内收到邮件。该邮件可能隐藏
              在您的垃圾邮件文件夹中。`,
  [k.RESENT_INSTRUCTIONS]: `重新发送说明`,
  [k.PASSWORD_CHANGE_SUCCESSFUL]: `密码更改成功`,
  [k.YOUR_PASSWORD_HAS_BEEN_RESET_S]: `您的密码已成功重置，账户为：`,
  [k.CONTINUE_TO_YOUR_UNIFIZE_APP]: `继续前往Unifize应用`,
  [k.SERVER_ERROR]: `服务器错误`,
  [k.RELOAD]: `重新加载`,
  [k.LOGOUT]: `注销`,
  [k.XL]: `2xl`,
  [k.FORGOT_PASSWORD]: `忘记密码？`,
  [k.SIGN_UP_NOW]: `立即注册！`,
  [k.THIS_EMAIL_ADDRESS_IS_NOT_VERI]: `此电子邮件地址未经验证`,
  [k.THE_USERNAME_OR_PASSWORD_IS_IN]: `用户名或密码不正确`,
  [k.TOO_MANY_FAILED_LOGIN_ATTEMPTS]: `登录尝试失败次数过多，请稍后再试`,
  [k.SOMETHING_WENT_WRONG_TRY_AGAI]: `出错了，请稍后再试`,
  [k.PLEASE_CHECK_YOUR_INBOX]: `请检查您的收件箱`,
  [k.VERIFYING_YOUR_LINK]: `正在验证您的链接`,
  [k.NO_CHARTS_FOUND]: `未找到图表`,
  [k.REFRESH1]: `刷新`,
  [k.SELECT_FIELD1]: `选择字段`,
  [k.TASKLIST]: `任务列表`,
  [k.MANDATORY1]: `必填`,
  [k.MANDATORY_FIELD_REMAINING]: `剩余必填字段`,
  [k.OPEN_CHECKLIST]: `打开检查表`,
  [k.CARETLEFTFILLED]: `填充的左插入符号`,
  [k.CLICK_TO_ADD_DESCRIPTION]: `点击添加描述`,
  [k.VIEW_IN_ACTIVE_CHAT]: `在收件箱中查看`,
  [k.UNABLE_TO_PERFORM_ACTION]: `无法执行操作`,
  [k.YOU_SHOULD_NAVIGATE_TO_CONVERS]: `您应该导航到对话以执行此操作。`,
  [k.TO_PERFORM_THIS_ACTION]: `执行此操作`,
  [k.CONVERSATION_DIALOG]: `对话框`,
  [k.CONVERSATION_DIALOG1]: `#对话框`,
  [k.DATEACTIVE]: `日期活动2`,
  [k.DATEACTIVE1]: `日期活动`,
  [k.FILES_FROM_UNIFIZE_CONVERSATIO]: `来自Unifize对话的文件`,
  [k.ATTACH_FILES_FROM_YOUR_COMPUTE]: `从您的计算机附加文件`,
  [k.CC]: `抄送`,
  [k.BCC]: `密送`,
  [k.SUBJECT]: `主题`,
  [k.SEND_AS_EMAIL]: `作为电子邮件发送`,
  [k.DISCARD]: `丢弃`,
  [k.SEND]: `发送`,
  [k.FILES_IN_CHATROOM]: `聊天室中的文件`,
  [k.ACCESS_REQUEST]: `访问请求`,
  [k.PEOPLE_HAVE_REQUESTED_TO_ACCES]: `人已请求访问此私密
            对话`,
  [k.ACCEPT]: `接受`,
  [k.PEOPLE]: `人`,
  [k.HAVE_REQUESTED_TO]: `已请求
              加入对话`,
  [k.RESPOND]: `回应`,
  [k.HAS_REQUESTED_TO_JOIN]: `已请求加入
          对话`,
  [k.FAVOURITE]: `收藏`,
  [k._35]: `;`,
  [k.CHANGE_PROCESS_TYPE]: `更改流程类型`,
  [k.TYPE2]: `类型-`,
  [k.DAYS_OLD]: `天前`,
  [k.LESS_THAN_A_DAY_OLD]: `不到一天前`,
  [k.LINK_COPIED]: `链接已复制`,
  [k.CONVERSATION_LINK_HAS_BEEN_COP]: `记录链接已被复制`,
  [k.CONVERSATION_LINK]: `记录链接`,
  [k.DOWNLOAD_JSON]: `下载JSON`,
  [k.FILES1]: `文件（`,
  [k.NO_RESULTS_FOR]: `没有结果，关于`,
  [k.EMAIL_ADDRESS_COPIED]: `电子邮件地址已复制`,
  [k.USE_COPIED_EMAIL_ADDRESS_TO_FO]: `使用复制的电子邮件地址将邮件转发到此记录`,
  [k.FORWARD_MAIL_HERE]: `转发邮件到这里`,
  [k.PRIVACY]: `隐私`,
  [k.HIDE_EVERYTHING1]: `（隐藏所有内容）`,
  [k.HIDE_ONLY_CHAT_CONTENT1]: `（仅隐藏聊天内容）`,
  [k.PROCESS_BUILDER]: `流程构建器`,
  [k.RELATED_CONVERSATIONS]: `相关记录`,
  [k.MOREMENUFILLED]: `更多菜单填充`,
  [k.MOREMENU]: `更多菜单`,
  [k.MORE2]: `更多`,
  [k.V]: `V`,
  [k.REVISIONS1]: `修订版本`,
  [k.CHAT_INPUT]: `聊天输入`,
  [k.PLUS]: `加号`,
  [k.PLUSCHATICON]: `加号聊天图标`,
  [k.D]: `d`,
  [k.FORWARD_TO]: `转发给`,
  [k.FORWARD]: `转发`,
  [k.UPLOAD_IMAGE]: `上传图片`,
  [k.ARE_YOU_SURE_YOU_WANT_TO_UPLOA]: `您确定要上传此图片吗？`,
  [k.OWNER2]: `所有者`,
  [k.SELECTED1]: `已选择`,
  [k.RECENT]: `最近`,
  [k.ADD_LINK]: `添加链接`,
  [k.ENTER_VALID_URL]: `输入有效URL`,
  [k.MENTIONBUTTON]: `提及按钮`,
  [k.NO_RESULTS_FOUND]: `未找到结果`,
  [k.EVERY_PARTICIPANT_OF_THE_CONV]: `（对话的每个参与者）`,
  [k.CURRENT_OWNER_OF_THE_CONVERSA]: `（对话的当前所有者）`,
  [k.CREATOR_OF_THE_CONVERSATION]: `（对话的创建者）`,
  [k.LOADING_MESSAGES]: `加载消息中...`,
  [k.JOIN]: `加入`,
  [k.FULL_NAME_OPTIONAL]: `全名（可选）`,
  [k.EMAIL_ADDRESS1]: `电子邮件地址`,
  [k.SELECT_ROLE]: `选择角色`,
  [k.SEND_INVITE]: `发送邀请`,
  [k.ADD_PARTICIPANTS_OR_GROUPS]: `添加参与者或群组`,
  [k.NAME_EMAIL_OR_GROUP]: `姓名、邮箱或群组`,
  [k.INVITE]: `邀请"`,
  [k.NO_RESULTS_FOR1]: `没有结果，关于"`,
  [k.TO_INVITE_SOMEONE_EXTERNALLY]: `要邀请外部人员，请使用其电子邮件地址。例如`,
  [k.JOHN_DOE_ACME_COM]: `john.doe@acme.com`,
  [k.TO_CONVERSATION]: `到记录`,
  [k.SEND_INVITES]: `发送邀请`,
  [k.PARTICIPANTS1]: `参与者`,
  [k.ADD_PARTICIPANTS_OR_GROUPS1]: `+ 添加参与者或群组`,
  [k.PARTICIPANT]: `参与者`,
  [k.CURVE]: `曲线`,
  [k.DELETED_USER]: `已删除用户`,
  [k.CHAT_WITH]: `与...聊天`,
  [k.START_RELATED_CONVERSATION]: `开始相关记录`,
  [k.OTHER]: `其他`,
  [k.ADD_TO_CONVERSATION]: `添加到记录`,
  [k.MEMBER1]: `成员`,
  [k.UPLOAD_FILES]: `上传文件`,
  [k.FROM_PRIVATE_CONVERSATION]: `从私密对话`,
  [k.START_PROCESS]: `开始流程`,
  [k.REMOVE_OWNER]: `移除所有者`,
  [k.INVITE1]: `邀请`,
  [k.INVITE_VIA_EMAIL]: `通过电子邮件邀请`,
  [k.ASSIGN_OWNER]: `指定所有者`,
  [k.NOOWNERACTIVE]: `无所有者活动`,
  [k.NOOWNER]: `无所有者`,
  [k.ASSIGN_OWNER1]: `指定所有者`,
  [k.NO_OWNER]: `无所有者`,
  [k.MESSAGE]: `消息`,
  [k.SET_PRIORITY]: `设置优先级`,
  [k.SET_DUE_DATE]: `设置截止日期`,
  [k.SET_PRIORITY_FOR_CONVERSATION]: `为此记录设置优先级`,
  [k.BOLD]: `粗体`,
  [k.GRAY2]: `灰色.200`,
  [k.PRIORITY2]: `优先级：`,
  [k.FAILED_TO_UPLOAD]: `上传失败`,
  [k.UPLOADING]: `上传中`,
  [k.RESTRICTED_ACCESS]: `访问受限`,
  [k.THE_CONVERSATION_YOU_ARE_TRYIN]: `您尝试访问的对话不对您的
              账户开放。请联系您的组织管理员获取访问权限。`,
  [k.FAILED_TO_LOAD_THE_CHATROOM]: `加载聊天室失败`,
  [k.CONVERSATION_NOT_FOUND]: `未找到对话`,
  [k.DEFINE_NEW]: `定义新的`,
  [k.CHATROOMSEARCH]: `聊天室搜索`,
  [k.X3]: `X`,
  [k.ADDITIONAL_COMMENTS]: `附加评论`,
  [k.SKIP]: `跳过`,
  [k.ARCHIVE]: `归档`,
  [k.THIS_CONVERSATION]: `此对话`,
  [k.ARCHIVE1]: `归档`,
  [k.CROP_UPLOAD]: `裁剪并上传`,
  [k.FILEINPUT]: `文件输入`,
  [k.BOOLEAN]: `布尔值`,
  [k.DETAILS_OBJECTIVE]: `详情/目标`,
  [k.DUE_DATE]: `截止日期`,
  [k.START_DIRECT_CONVERSATION]: `开始直接对话`,
  [k.YOU_CANT_CHAT_WITH_YOURSELF]: `您不能与自己聊天`,
  [k.CHOOSE_USER_TO_CHAT_WITH]: `选择要聊天的用户`,
  [k.TO_INVITE_SOMEONE_EXTERNALLY1]: `要邀请外部人员，请使用其电子邮件地址。
            例如john.doe@acme.com`,
  [k.PARENTS]: `父级`,
  [k.CHILDREN]: `子级`,
  [k.OVERDUE2]: `逾期（`,
  [k.COMPLETED2]: `已完成（`,
  [k.I]: `我`,
  [k.M_OWNER]: `是所有者（`,
  [k.RELATED_CHILDREN]: `相关子级（`,
  [k.RELATED_PARENTS]: `相关父级（`,
  [k.SHOWING]: `显示`,
  [k.OPTION]: `选项`,
  [k.I_M_THE_OWNER]: `我是所有者`,
  [k.RELATED]: `相关`,
  [k.DATEWARNING]: `日期警告`,
  [k.COMPLETED3]: `已完成`,
  [k.INCOMPLETE1]: `未完成`,
  [k.RELATED1]: `相关`,
  [k.NO_LONGER_MATCHES_THE_LIST_F]: `不再匹配列表/过滤器`,
  [k.SEND_A_DIRECT_MESSAGE]: `发送直接消息`,
  [k.START_WITH_THIS_SOLUTION]: `从此解决方案开始`,
  [k.NO_MATCHING_RESULTS1]: `没有匹配的结果`,
  [k.THERE_WEREN_T_ANY_CONVERSATION]: `没有符合您过滤条件的对话。`,
  [k.TRY_WIDENING_YOUR_SEARCH]: `尝试扩大您的搜索范围。`,
  [k.CONGRATULATIONS]: `恭喜！`,
  [k.YOU_HAVE_UNREAD_CONVERSATION]: `您这里有0条未读对话。`,
  [k.TRY_APPLYING_OTHER_FILTERS]: `尝试应用其他过滤器。`,
  [k.EDIT_FILTER]: `编辑过滤器`,
  [k.SAVE_FILTER]: `保存过滤器`,
  [k.ERROR_EDITING_FILTER]: `编辑过滤器出错`,
  [k.FILTER_CANNOT_BE_SAVED]: `过滤器无法保存`,
  [k.SORT_BY3]: `排序方式`,
  [k.CUSTOM]: `自定义`,
  [k.VIEW_AND_SELECT_FROM_ALL_STATU]: `查看并从所有状态中选择`,
  [k.STATUS2]: `状态`,
  [k.CLOSEFILTER]: `关闭过滤器`,
  [k.CLEAR]: `清除`,
  [k.ALL_TYPES]: `所有类型`,
  [k.SAVED_FILTERS]: `已保存的过滤器`,
  [k.QUICK_FILTERED_LISTS]: `快速过滤列表`,
  [k.SUGGESTED]: `建议`,
  [k.ALL_CONVERSATIONS]: `所有对话`,
  [k.ALL_CONVERSATIONS1]: `所有对话`,
  [k.FAVOURITES]: `收藏`,
  [k.FAVOURITES1]: `收藏`,
  [k.STAR]: `星标`,
  [k.ACTIVEQUICKFILTER]: `活动快速过滤器`,
  [k.DEFAULTQUICKFILTER]: `默认快速过滤器`,
  [k.BACKARROW]: `返回箭头`,
  [k.CHANGE]: `更改`,
  [k.CONVERSATION_TYPE_NOT_FOUND]: `未找到对话类型`,
  [k.ALL_PROCESSES]: `所有流程`,
  [k.ALL_TASKS]: `所有任务`,
  [k.ALL_APPROVALS]: `所有审批`,
  [k.SEARCH_CONVERSATION]: `搜索对话`,
  [k.ADD_A_DEPARTMENT]: `添加部门`,
  [k.SEARCH_FOR_DEPARTMENTS]: `搜索部门`,
  [k.NO_DEPARTMENT]: `无部门`,
  [k.CREATE_NEW_DEPARTMENT]: `创建新部门`,
  [k.ENTER_YOUR_DEPARTMENT]: `输入您的部门`,
  [k.OBJECT1]: `对象`,
  [k.CLONE1]: `克隆`,
  [k.ORGANISE]: `整理`,
  [k.CREATE_NEW_FOLDER]: `创建新文件夹`,
  [k.NEW_FOLDER]: `新文件夹`,
  [k.MEDIUM]: `中等`,
  [k.MOVE_HERE]: `移动到这里`,
  [k.ALL_ORG_FILES]: `所有组织文件`,
  [k.MY_DRIVE]: `我的云盘`,
  [k.V1]: `v`,
  [k.CURRENT_VERSION]: `当前版本`,
  [k.MAKE_CURRENT1]: `设为当前`,
  [k.VERSION_HISTORY]: `版本历史`,
  [k.PIN]: `固定`,
  [k.TO_ACTIVE_CONVERSATION]: `到活动对话`,
  [k.PIN1]: `固定`,
  [k.PIN_TO_ACTIVE_CONVERSATION]: `固定到活动对话`,
  [k.ORGANISE1]: `整理`,
  [k.TRASH]: `垃圾箱`,
  [k.SEE_RELATED_CONVERSATIONS]: `查看相关对话`,
  [k.FILE_NAME]: `文件名`,
  [k.SIZE]: `大小`,
  [k.LAST_MODIFIED]: `最后修改`,
  [k.UPLOADED_BY]: `上传者`,
  [k.MY_FILES]: `我的文件`,
  [k.ALL_FILES]: `所有文件`,
  [k.PIN_CONVERSATION]: `固定对话`,
  [k.PIN_FILE]: `固定文件"`,
  [k.TO1]: `"到"`,
  [k.ADD_MORE]: `添加更多`,
  [k.OPTIONAL_COMMENT]: `可选评论：`,
  [k.FILES_NOT_FOUND]: `未找到文件`,
  [k.NO_RESULT]: `无结果`,
  [k.UPLOAD_FILE]: `上传文件`,
  [k.SORT_BY_ALPHABET]: `按字母排序`,
  [k.LAST_MODIFY]: `最后修改`,
  [k.RECENTLY_VIEWED]: `最近查看`,
  [k.UPLOAD_A_FILE]: `上传文件`,
  [k.UPLOAD_FILE1]: `上传文件`,
  [k.UPLOAD_NEW_VERSION1]: `上传新版本`,
  [k.THIS_FILE_IS_SHARED_ON_A_FOLDE]: `此文件已在文件夹中共享，并与其他线程共享。
                  上传新版本将更改所有这些文件。（将保留最后5个版本的旧版本历史记录）`,
  [k.IT_LOOKS_LIKE_YOU_ARE_UPLOADIN]: `看起来您正在上传文件"`,
  [k.IS_THAT_CORRECT]: `"的新版本。是否正确？`,
  [k.ENTER_VERSION_NOTES_COMMENTS]: `输入版本注释/评论（可选）`,
  [k.CONTINUE]: `继续`,
  [k.NO_ORGS_WITH_GIVEN_NAME]: `没有给定名称的组织`,
  [k.DASHBOARD1]: `仪表板`,
  [k.MANAGE1]: `管理`,
  [k.CRASH]: `崩溃`,
  [k.DISPLAYNAME_ASC]: `显示名称:升序`,
  [k.ACTIVE]: `活动`,
  [k.CLONE_ORG]: `克隆组织`,
  [k.COPY_LINK]: `复制链接`,
  [k.CREATE_NEW_ORG]: `创建新组织`,
  [k.TEAM_NAME]: `团队名称`,
  [k.INVITE_YOUR_TEAM_MEMBERS]: `邀请您的团队成员`,
  [k.TEAM_MEMBER_OPTIONAL]: `团队成员（可选）`,
  [k.DOMAIN_NAME]: `域名`,
  [k.OPTIONAL1]: `（可选）`,
  [k.ALLOW_ANYONE_WITH]: `允许任何使用`,
  [k.EMAIL_TO_JOIN_THIS_TEAM]: `邮箱的人加入此团队。`,
  [k.ALLOW_ANYONE_WITH_GIVEN_DOMAIN]: `允许任何使用给定域名的人加入此团队`,
  [k.ORGDARK]: `组织暗色`,
  [k.ORG2]: `组织`,
  [k.CHANGE_PASSWORD]: `更改密码`,
  [k.CIRCLECHECK]: `圆形勾选`,
  [k.PASSWORD_DOES_NOT_MATCH]: `（密码不匹配）`,
  [k.CHANGE_ORG]: `更改组织`,
  [k.UPDATE_NAME]: `更新名称`,
  [k.CHANGE_PROFILE_PICTURE]: `更改个人资料图片`,
  [k.CHANGE_PASSWORD1]: `更改密码`,
  [k.ORG_SETTINGS1]: `组织设置`,
  [k.A_NEW_VERSION_OF_UNIFIZE_HAS_B]: `Unifize的新版本已发布。`,
  [k.UPDATE_NOW]: `立即更新`,
  [k.VIEW_AS]: `查看为`,
  [k.SETTING_UP_YOUR_PROFILE]: `设置您的个人资料`,
  [k.PLEASE_COMPLETE_YOUR_PROFILE_B]: `请完成下面的个人资料，以便开始使用Unifize`,
  [k.FULL_NAME]: `全名`,
  [k.CREATE_PASSWORD]: `创建密码`,
  [k.PROFILE_PIC]: `个人资料图片`,
  [k.IMAGE1]: `图片/*`,
  [k.ADD_PROFILE_PHOTO_OPTIONAL]: `添加个人资料照片（可选）`,
  [k.SOMETHING_WENT_WRONG]: `出了点问题 :(`,
  [k.PLEASE_TRY_CLICKING_ON_THE_INV]: `请尝试再次点击邀请链接！`,
  [k.SETTING_UP_UNIFIZE_FOR_YOU]: `正在为您设置Unifize`,
  [k.VERIFYING_CREDENTIALS]: `验证凭据`,
  [k.DELETED_A]: `删除了一个`,
  [k.FORWARDED_FROM]: `转发自`,
  [k.HID_A_MESSAGE]: `隐藏了
          一条消息。`,
  [k.UNHIDE]: `取消隐藏`,
  [k.FIRST]: `第一个`,
  [k.UNARCHIVE1]: `取消归档`,
  [k.IMG_LOADING]: `图片加载中...`,
  [k.UPDATED]: `已更新`,
  [k.CANCELLED_THIS_CONVERSATION]: `取消了此对话`,
  [k.CANCELLED1]: `已取消`,
  [k.COMPLETED_THIS_CONVERSATION]: `完成了此对话`,
  [k.THIS_IS_YOUR_DIRECT_MESSAGE_WI]: `这是您与@`,
  [k.THIS_CONVERSATION_IS_PRIVATE]: `此对话是私密的`,
  [k.REOPENED_THIS_CONVERSATION]: `重新打开了此对话`,
  [k.REOPENED]: `已重新打开`,
  [k.PHOTO1]: `照片`,
  [k.STARTED_THIS_CONVERSATION]: `开始了此对话`,
  [k.STARTED]: `已开始`,
  [k.UPDATED_STATUS_OF_THIS_CONVERS]: `将此对话的状态更新为`,
  [k.UPDATED_STATUS_OF_THE_CONVERSA]: `更新了对话的状态`,
  [k.UPDATED_THE_DUE_DATE_TO]: `将截止日期更新为`,
  [k.SET_THE_DUE_DATE_TO]: `将截止日期设置为`,
  [k.REMOVED_THE_DUE_DATE]: `移除了截止日期`,
  [k.READ]: `已读`,
  [k.DELIVERED]: `已送达`,
  [k.TO2]: `收件人：`,
  [k.CC1]: `抄送：`,
  [k.BCC1]: `密送：`,
  [k.NO_CONTENT]: `无内容`,
  [k.ATTACHMENTS]: `附件`,
  [k.ATTACHMENT]: `附件`,
  [k.HIDE_DETAILS]: `隐藏详情`,
  [k.VIEW_FULL_EMAIL]: `查看完整邮件`,
  [k.FILL_CHECKLIST_FROM_EMAIL]: `根据邮件填写检查表`,
  [k.LOADING2]: `加载中...`,
  [k.DELETED_A_FILE]: `删除了一个文件。`,
  [k.MAIL]: `邮件`,
  [k.UPLOADED_A_FILE]: `上传了一个文件`,
  [k.SENT_AN_EMAIL]: `发送了一封邮件`,
  [k.ADDED_A_FORM]: `添加了一个表单`,
  [k.TO_THE_CHECKLIST]: `到检查表`,
  [k.REMOVED_A_FORM]: `移除了一个表单`,
  [k.FROM_THE_CHECKLIST1]: `从检查表`,
  [k.ADDED_PARENT]: `添加了父级`,
  [k.REMOVED_PARENT]: `移除了父级`,
  [k.ADDED_CHILD]: `添加了子级`,
  [k.REMOVED_CHILD]: `移除了子级`,
  [k.UPDATED_THE_OBJECTIVE_TO]: `将目标更新为：`,
  [k.ADDED_OBJECTIVE]: `添加了目标：`,
  [k.REMOVED_OBJECTIVE]: `移除了目标`,
  [k.CHANGED_THE_OWNER_FROM]: `将所有者从`,
  [k.ASSIGNED]: `指派了`,
  [k.AS_THE_OWNER]: `作为所有者`,
  [k.REMOVED]: `移除了`,
  [k.ADDED_CHILD_CONVERSATION]: `添加了子对话`,
  [k.REMOVED_CHILD_CONVERSATION]: `移除了子对话`,
  [k.UPDATED_THE_PRIORITY_FROM]: `将优先级从`,
  [k.CHANGED_THE_PRIVACY_SETTING_TO]: `将隐私设置更改为`,
  [k.TURNED_OFF_REMINDERS_FOR_THIS]: `关闭了此对话的提醒。`,
  [k.TURN_ON]: `开启`,
  [k.TURNED_ON_REMINDERS_FOR_THIS_C]: `开启了此对话的提醒。`,
  [k.TURN_OFF]: `关闭`,
  [k.UNIFIZE_ASSISTANT]: `Unifize助手`,
  [k.TURN_OFF_REMINDERS]: `关闭提醒`,
  [k.REMINDERS_HAVE_BEEN_TURNED_OFF]: `提醒已关闭`,
  [k.OF_THIS_CONVERSATION]: `对此
          对话`,
  [k.CREATED_A_REVISION]: `创建了一个修订版本`,
  [k.MADE]: `设置`,
  [k.AS_THE_CURRENT_REVISION1]: `为当前修订版本。`,
  [k.FROM]: `来自 #`,
  [k.FILES2]: `文件`,
  [k.STARTED_THIS_CONVERSATION_FROM]: `从以下位置开始了此对话`,
  [k.FORWARDED_FROM1]: `转发自`,
  [k.SENT_THIS_MESSAGE_FROM]: `从以下位置发送了此消息`,
  [k.THREAD]: `线程`,
  [k.DUE_ON]: `截止于`,
  [k.UPDATED1]: `更新了`,
  [k.TITLE_TO]: `标题为`,
  [k.FROM1]: `从`,
  [k.ADDED]: `添加了`,
  [k.THE]: `这个`,
  [k.INVITED]: `邀请了`,
  [k.TO_THE_CHATROOM]: `到聊天室`,
  [k.JOINED_THE_CONVERSATION]: `加入了对话`,
  [k.TODAY]: `今天`,
  [k.LOADMORE]: `加载更多`,
  [k.LOADING_MORE_CONVERSATIONS]: `正在加载更多对话...`,
  [k.SIGNATORIES]: `签署人`,
  [k._40]: `@`,
  [k.MESSAGEWITHMENTION]: `带提及的消息`,
  [k.MESSAGEWITHOUTMENTION]: `不带提及的消息`,
  [k.REPLY_AS_EMAIL]: `以电子邮件回复`,
  [k.FORWARD_AS_EMAIL]: `以电子邮件转发`,
  [k.START1]: `开始`,
  [k.STEP_DISMISSED]: `步骤已忽略`,
  [k.UNDO]: `撤销`,
  [k.HEY]: `嘿`,
  [k.CAN_YOU_COMPLETE_THIS_STEP]: `，您能完成这一步吗？`,
  [k.DISMISS]: `忽略`,
  [k.CHECKLIST_FIELD_FILL]: `检查表字段填写`,
  [k.YOU_CAN_ACCESS_THE_CONVERSATIO]: `参与者授予您访问权限后，您可以访问对话。`,
  [k.REQUEST_SENT]: `请求已发送`,
  [k.REQUEST_ACCESS]: `请求访问`,
  [k.THANK_YOU_FOR_YOUR_INTEREST]: `感谢您的关注`,
  [k.OUR_SALES_TEAM_WILL_GET_IN_TOU]: `我们的销售团队将很快与您联系`,
  [k.VALIDATING_YOUR_EMAIL]: `验证您的电子邮件`,
  [k.SET_UP_NEW_ORG_ON_UNIFIZE]: `在Unifize上设置新组织`,
  [k.PLEASE_ENTER_YOUR_WORK_EMAIL_S]: `请输入您的工作邮箱，以便我们将您连接到您组织的私人空间。`,
  [k.TRY_SIGNING_IN]: `尝试登录`,
  [k.BY_CLICKING_SIGN_UP_YOU_ACC]: `点击"注册"，即表示您接受我们的`,
  [k.TERMS_OF_SERVICE]: `服务条款`,
  [k.AND_OUR]: `，以及我们的`,
  [k.PRIVACY_POLICY]: `隐私政策`,
  [k.SENDING_VERIFICATION_MAIL]: `发送验证邮件`,
  [k.ERROR_SENDING_VERIFICATION_MAI]: `发送验证邮件出错`,
  [k.CLICK_HERE_TO_RESEND]: `点击此处重新发送。`,
  [k.PLEASE_VERIFY_YOUR_EMAIL]: `请验证您的电子邮件`,
  [k.PLEASE_OPEN_YOUR]: `。
              请打开您的电子邮件，点击链接完成Unifize设置。`,
  [k.DIDN_T_GET_YOUR_EMAIL]: `没有收到您的电子邮件？`,
  [k.ERROR_VERIFYING_YOUR_LINK]: `验证您的链接时出错`,
  [k.CHECK_YOUR_INBOX_FOR_THE_LATES]: `请查看您的收件箱，获取我们发送的最新邮件。`,
  [k.ENTER_EMAIL_ADDRESS_TO_SIGN_UP]: `输入电子邮件地址注册`,
  [k.YOU_WILL_RECEIVE_A_VERIFICATIO]: `您将在几分钟内收到一封验证邮件`,
  [k.DEPARTMENT]: `部门`,
  [k.DEPARTMENT1]: `部门`,
  [k.PROCESS1]: `流程`,
  [k.FILTERS1]: `过滤器：`,
  [k.SHOW_TOTAL]: `显示总计`,
  [k.SHOW_AVERAGE]: `显示平均值`,
  [k.LAST_UPDATED]: `最后更新：`,
  [k.LAST_DAYS]: `最近7天`,
  [k.LAST_MONTH]: `上个月`,
  [k.CHOOSE_DATE]: `选择日期`,
  [k.LAST_WEEK]: `上周`,
  [k.ADD_DATE_RANGE_MANUALLY]: `手动添加日期范围`,
  [k.USER_NAME]: `用户名`,
  [k.CONVERSATIONS_CREATED_DURING]: `在此期间创建的对话`,
  [k.WHERE_USER_IS_A_PARTICIPANT]: `用户是参与者的地方`,
  [k.NOW_COMPLETED]: `现已完成`,
  [k.STILL_PENDING]: `仍待处理`,
  [k.CURRENT_PENDING_CONVERSATIONS]: `当前待处理的对话`,
  [k.UNREAD_BY_USER]: `用户未读`,
  [k.OWNED_BY_USER]: `用户拥有`,
  [k.MARKED_AS_CRITICAL]: `标记为关键`,
  [k.CONVERSATIONS_COMPLETED_DURING]: `在此期间完成的对话`,
  [k.CREATED_BY_USER]: `用户创建`,
  [k.COMPLETED_BY_USER]: `用户完成`,
  [k.LAST_ACTIVE]: `最后活动`,
  [k.AVERAGE]: `平均值：`,
  [k.TOTAL]: `总计：`,
  [k.CONTACTS]: `联系人`,
  [k.LOCK_GROUP]: `锁定群组`,
  [k.ONLY_THE_GROUP_OWNER_CAN_MAKE]: `只有群组所有者可以对锁定的群组进行更改`,
  [k.EDIT_GROUP]: `编辑群组`,
  [k.CREATE_NEW_GROUP]: `创建新群组`,
  [k.GROUP_NAME]: `群组名称`,
  [k.ADD_PARTICIPANTS1]: `添加参与者`,
  [k.GROUP_OWNERS]: `群组所有者`,
  [k.CREATE_GROUP]: `创建群组`,
  [k.GROUP_LOGO]: `群组徽标`,
  [k.GROUP_NAME1]: `群组名称`,
  [k.GROUP_OWNERS1]: `群组所有者`,
  [k.ADDED_ON]: `添加于`,
  [k.RESET_PASSWORD]: `重置密码`,
  [k.RESEND_INVITE]: `重新发送邀请`,
  [k.MMM_DD_YYYY_HH_MM_A1]: `MMM DD, YYYY hh:mm A`,
  [k.DATE_COMPLETED]: `完成日期`,
  [k.GROUPS1]: `群组（`,
  [k.PROCESSES1]: `流程（`,
  [k.ONBOARDING_PROGRESS]: `入职进度`,
  [k.PHONE_NUMBER]: `电话号码`,
  [k.MESSAGE1]: `消息`,
  [k.ENABLE]: `启用`,
  [k.ADMIN]: `管理员`,
  [k.MAKE_MEMBER]: `设为成员`,
  [k.MAKE_ADMIN]: `设为管理员`,
  [k.MMM_DD_YYYY_H_MM_A]: `MMM DD, YYYY h:mm a`,
  [k.MMM_DD_YYYY_H_MM_A1]: `MMM DD, YYYY h:mm A`,
  [k.COLUMN2]: `列-`,
  [k.ROLE]: `角色`,
  [k.VIEW_PROFILE]: `查看个人资料`,
  [k.DIRECT_MESSAGE]: `直接消息`,
  [k.PEOPLE1]: `人员`,
  [k.ADMIN1]: `管理员？`,
  [k.MEMBER2]: `成员？`,
  [k.DISABLING_A_USER_S_ACCOUNT_WIL]: `禁用用户的账户将清除他们的所有缓存数据。`,
  [k.MAKE]: `使`,
  [k.S_ACCOUNT]: `的账户`,
  [k.USER_EXAMPLE_COM]: `user@example.com`,
  [k.ENTER_DISPLAY_NAME]: `输入显示名称`,
  [k.IN]: `在`,
  [k.SEARCH_FOR_COUNTRY]: `搜索国家`,
  [k.NO_PHONE_NUMBER]: `无电话号码`,
  [k.ME2]: `我`,
  [k.CAN_T_FIND_ANYONE_WITH_THIS_NA]: `找不到具有此名称的任何人。`,
  [k.CAN_T_FIND_SOMEONE]: `找不到某人？`,
  [k.TO_UNIFIZE_VIA_EMAIL]: `通过电子邮件到Unifize`,
  [k.INVITE_THEM_TO_UNIFIZE_VIA_EMA]: `通过电子邮件邀请他们加入Unifize`,
  [k.CIRCLE]: `圆形`,
  [k.ME_ALWAYS_SELECTS_THE_VIEWER]: `我（始终选择查看者）`,
  [k.SEARCH_PEOPLE]: `搜索人员`,
  [k.E_G_JOHN_DOE_XYZ_COM_OR_JOHN]: `例如 john.doe@xyz.com 或 John Doe`,
  [k.OUTLINE]: `轮廓`,
  [k.VIA_EMAIL]: `通过电子邮件`,
  [k.USERWITHDISPLAYNAME]: `带显示名称的用户`,
  [k.SELECT_MEMBERS]: `选择成员`,
  [k.MEMBERS2]: `成员`,
  [k.MEMBER3]: `成员-`,
  [k._41]: `30`,
  [k.PROFILE_PIC1]: `个人资料图片`,
  [k.USER_NOT_FOUND]: `未找到用户`,
  [k.DEFINE]: `定义`,
  [k.DRAFT_PROCESS]: `草稿流程`,
  [k.SEARCH_PROCESS]: `搜索流程`,
  [k.CANNOT_REMOVE_STATUS]: `无法移除状态"`,
  [k.THERE_ARE_OPEN_CONVERSATIONS_W]: `有使用该状态的开放对话。您需要先将所有这些对话的状态更改为不同的状态，然后才能移除"`,
  [k.CONVERSATIONS_MARKED_AS]: `标记为"`,
  [k.SEND_MAIL_WITHOUT_INVITES]: `发送邮件而不邀请`,
  [k.SEND_WITH_INVITES]: `发送并邀请`,
  [k._42]: `99+`,
  [k.CHAT_HISTORY]: `聊天历史`,
  [k.BA]: `#1581BA`,
  [k._43]: `00`,
  [k.FFF]: `#fff`,
  [k._44]: `10`,
  [k._45]: `17`,
  [k._46]: `8`,
  [k._47]: `13`,
  [k._48]: `#888`,
  [k.EM3]: `1.5em`,
  [k.INITIAL]: `initial`,
  [k.A_A_A]: `#2A2A2A`,
  [k.F_A]: `#f1a208`,
  [k.BBBBBB]: `#BBBBBB`,
  [k.A_A_A1]: `#2a2a2a`,
  [k.URL_AVATAR_PATTERN]: `url(#avatar-pattern-`,
  [k.AVATAR_PATTERN]: `avatar-pattern-`,
  [k.OBJECTBOUNDINGBOX]: `objectBoundingBox`,
  [k.SCALE]: `scale(.00163)`,
  [k.GROUP_AVATAR]: `#group-avatar-`,
  [k.GROUP_AVATAR1]: `group-avatar-`,
  [k._49]: `612`,
  [k._50]: `7`,
  [k._51]: `18`,
  [k._52]: `0 0`,
  [k._53]: `12`,
  [k._54]: `24`,
  [k._55]: `#888888`,
  [k.F_ED]: `#2F80ED`,
  [k.IC_FORMAT_ALIGN_CENTER_PX]: `ic_format_align_center_24px`,
  [k.IC_FORMAT_ALIGN_JUSTIFY_PX]: `ic_format_align_justify_24px`,
  [k.IC_FORMAT_ALIGN_LEFT_PX]: `ic_format_align_left_24px`,
  [k.IC_FORMAT_ALIGN_RIGHT_PX]: `ic_format_align_right_24px`,
  [k.IC_FORMAT_LIST_BULLETED_PX]: `ic_format_list_bulleted_24px`,
  [k.IC_FORMAT_ITALIC_PX]: `ic_format_italic_24px`,
  [k.IC_FORMAT_LIST_NUMBERED_PX]: `ic_format_list_numbered_24px`,
  [k.IC_FORMAT_UNDERLINED_PX]: `ic_format_underlined_24px`,
  [k.UNABLE_TO_LOAD_DOCUMENT]: `无法加载文档。`,
  [k.TO_CREATE_AREA_HIGHLIGHT_HOLD]: `要创建区域高亮，按住⌥ Option键（Alt），然后点击并拖动。`,
  [k._56]: `…`,
  [k.SCREENSHOT]: `截图`,
  [k.RESET_HIGHLIGHTS]: `重置高亮`,
  [k.FUNCTION]: `函数`,
  [k.PAGE1]: `.页面`,
  [k.ADD_COMMENT]: `添加评论`,
  [k.ADD_A_COMMENT]: `添加评论`,
  [k.START_TYPING_YOUR_COMMENT_HERE]: `在此开始输入您的评论...`,
  [k.ADD_COMMENT1]: `添加评论`,
  [k.CUSTOM1]: `自定义`,
  [k.AUTOMATIC_ZOOM]: `自动缩放`,
  [k.ACTUAL_SIZE]: `实际大小`,
  [k.PAGE_FIT]: `页面适应`,
  [k.PAGE_WIDTH]: `页面宽度`,
  [k._57]: `75%`,
  [k._58]: `125%`,
  [k._59]: `150%`,
  [k._60]: `200%`,
  [k._61]: `300%`,
  [k._62]: `400%`,
  [k.PAGE_FIT1]: `页面适应`,
  [k.PAGE_ACTUAL]: `页面实际大小`,
  [k.PAGE_WIDTH1]: `页面宽度`,
  [k.EMAIL_PLACEHOLDER]: `例如 john.doe@unifize.com`,
  [k.NEW_PASSWORD_PLACEHOLDER]: `输入新密码`,
  [k.FILES_TOOLTIP_TITLE]: `文件`,
  [k.CHECKLIST_TOOLTIP_TITLE]: `检查表`,
  [k.REFRESH_CHECKLIST_TOOLTIP_TITLE]: `刷新`,
  [k.OPEN_CHECKLIST_TOOLTIP_TITLE]: `打开检查表`,
  [k.RESTRICTED_ROOM_MODAL_MESSAGE]: `无法加载您正在尝试访问的聊天室。请稍后再试！`,
  [k.START_NEW]: `开始新建`,
  [k.FEED]: `信息流`,
  [k.MORE_OPTIONS]: `更多选项`,
  [k.GENERATE_JSON_SUCCESS]: `正在生成JSON。下载链接将在几分钟内通过电子邮件发送给您。`,
  [k.GENERATE_JSON_FAILURE]: `无法生成JSON`,
  [k.PREVENT_REQUESTER_MESSAGE]: `请求者不能添加签名。`,
  [k.ENTER_A_TITLE_FOR_THIS_PROCESS]: `为此流程输入标题`,
  [k.TEXT]: `文本`,
  [k.NUMBER]: `数字`,
  [k.DATE]: `日期`,
  [k.USER]: `用户`,
  [k.SECTION]: `部分`,
  [k.SUBSECTION]: `子部分`,
  [k.CONVERSATION2]: `对话`,
  [k.PARENT_CONVERSATION]: `父对话`,
  [k.CHILD_CONVERSATION]: `子对话`,
  [k.PDF]: `生成PDF`,
  [k.FILE_UPLOAD]: `文件上传`,
  [k.FORM]: `表单`,
  [k.REVISION]: `修订版本`,
  [k.LINKED_FIELD]: `链接字段`,
  [k.UPLOAD_FIELDS_FROM_CSV]: `从CSV上传字段`,
  [k.UPLOAD_FIELDS_JSON]: `从JSON上传字段`,
  [k.RICH_TEXT]: `富文本`,
  [k.CHECKLIST_FIELD_TEXT_DESCRIPTION]: "自由输入文本字段",
  [k.CHECKLIST_FIELD_NUMBER_DESCRIPTION]: "输入数字。可用于分析总计",
  [k.CHECKLIST_FIELD_DATE_DESCRIPTION]: "用户输入日期。手动或日期选择器。",
  [k.CHECKLIST_FIELD_USER_DESCRIPTION]: "在您的联系人或组织内选择用户",
  [k.CHECKLIST_FIELD_SECTION_DESCRIPTION]: "使用显著的可折叠部分划分检查表。",
  [k.CHECKLIST_FIELD_SUBSECTION_DESCRIPTION]: "在部分内添加可折叠子部分",
  [k.CHECKLIST_FIELD_CONVERSATION_DESCRIPTION]: "将另一个流程链接为父对话。",
  [k.CHECKLIST_FIELD_CHILD_CONVERSATION_DESCRIPTION]:
    "将另一个流程链接为子对话。",
  [k.CHECKLIST_FIELD_SELECT_DESCRIPTION]:
    "项目的下拉选择。可选：用户可以添加项目。",
  [k.CHECKLIST_FIELD_PDF_DESCRIPTION]: "使用模板生成检查表的可打印PDF。",
  [k.CHECKLIST_FIELD_FILE_DESCRIPTION]: "附加/上传文档或图像到字段。",
  [k.CHECKLIST_FIELD_FORM_DESCRIPTION]: "添加预配置表单。适用于多行项目。",
  [k.CHECKLIST_FIELD_APPROVAL_DESCRIPTION]: "对流程和文档应用数字签名。",
  [k.CHECKLIST_FIELD_REVISION_DESCRIPTION]: "创建和管理对话的修订版本",
  [k.CHECKLIST_FIELD_LINK_DESCRIPTION]: "链接到另一个流程（双向）。",
  [k.CHECKLIST_FIELD_UPLOAD_FROM_CSV_DESCRIPTION]:
    "上传Excel检查表快速创建检查表",
  [k.TOOLTIP_HOMESCREEN]: "主屏幕",
  [k.TOOLTIP_DASHBOARD]: "仪表板",
  [k.TOOLTIP_CONTACTS]: "联系人",
  [k.TOOLTIP_MANAGE]: "管理",
  [k.TOOLTIP_DIRECT_MESSAGES]: "直接消息",
  [k.SEND_RESPONSE_FROM_HERE]: "从这里发送回复",
  [k.APPROVAL_PERMISSIONS]: "审批权限",
  [k.APPROVAL_CAN_BE_CANCELLED_BY]: "审批只能由以下人员取消",
  [k.APPROVAL_SETTINGS_NOT_CONFIGURED]: "审批设置尚未配置",
  [k.DUE]: "截止",
  [k.PROCESS_WAS_DELETED]: "流程已删除",
  [k.IMPORTED_WITH_ERRORS]: "导入时有错误",
  [k.SEARCH_PROCESS]: "搜索流程",
  [k.ONLY_IMAGES_ARE_ALLOWED]: "只允许图片。",
  [k.UNABLE_TO_CLEAR_DB]: "无法清除数据库: ",
  [k.PREFERENCES]: "首选项",
  [k.LANGUAGE]: "语言",
  [k.LANGUAGE_SWITCHING_HINT]: "选择您想在Unifize中使用的语言",
  [k.LANGUAGE_SUPPORT_HINT]: "请联系您的管理员启用语言支持",
  [k.FIELD_NAME]: "字段名称",
  [k.ADD_NEW_FIELD]: "添加新字段",
  [k.SETTINGS]: "设置",
  [k.SHOW_HIDE_FIELD]: "显示/隐藏字段",
  [k.TRANSLATIONS]: `翻译`,
  [k.SUPPORTED_LANGUAGES]: `支持的语言`,
  [k.LANGUAGE]: `语言`,
  [k.ADD_NEW]: `+ 添加新的`,
  [k.NO_TRANSLATIONS_FOUND]: `未找到翻译。`,
  [k.CONTACT_SUPPORT]: `联系Unifize获取更多语言支持。`,
  [k.PREVIOUS]: `上一页`,
  [k.PAGE_SIZE]: `页面大小`,
  [k.ENTER_PAGE_NUMBER]: `输入页码`,
  [k.LANGUAGE_SWITCH]: `切换语言`,
  [k.LANGUAGE_INFO]: `您的组织支持的语言有：`,
  [k.ACTION]: `操作`,
  [k.PATH]: `路径`,
  [k.FAILED_TO_SWITCH_LANGUAGE]: `切换语言失败`,
  [k.ENTER_OPTIONAL_COMMENT_HERE]: "在此输入可选评论",
  [k.SELECT_ALL_PENDING]: "选择所有待处理",
  [k.SELECT_ALL_COMPLETE]: "选择所有已完成",
  [k.PENDING_CONVERSATIONS]: "例如：待处理对话",
  [k.NUM_PENDING_TASKS]: "例如：您有 #num 个待处理任务",
  [k.TAKE_ME_THERE]: "带我去那里",
  [k.REFRESHED_CHART_DATA_NOT_AVAILABLE]:
    "刷新后的图表数据不可用。请在几分钟后重试。",
  [k.AVAILABLE_CHARTS]: "可用图表",
  [k.SEARCH_CHARTS]: "搜索图表",
  [k.CHART_ALREADY_EXISTS_IN_DASHBOARD]: "此图表已存在于当前仪表板中",
  [k.FAILED_TO_LOAD_CHART]: "无法加载图表数据。请稍后刷新",
  [k.FAILED_TO_LOAD_CHART_DATA]: "无法加载图表。请稍后刷新",
  [k.NO_DATA_TO_DISPLAY]: "没有数据可显示",
  [k.DATE_UPDATED_SORT]: "更新日期",
  [k.PRIORITY_SORT]: "优先级",
  [k.STATUS_SORT]: "状态",
  [k.DATE_CREATED_SORT]: "创建日期",
  [k.DUE_DATE_SORT]: "截止日期",
  [k.RECENT_SORT]: "最近",
  [k.STALE_SORT]: "陈旧",
  [k.CRITICAL_SORT]: "关键",
  [k.LOW_SORT]: "低",
  [k.PENDING_SORT]: "待处理",
  [k.COMPLETE_SORT]: "完成",
  [k.NEWEST_SORT]: "最新",
  [k.OLDEST_SORT]: "最旧",
  [k.DUE_SOON_SORT]: "即将截止",
  [k.DUE_LATER_SORT]: "稍后截止",
  [k.ENTER_FILTER_NAME]: "输入过滤器名称",
  [k.ENTER_GROUP_NAME]: "输入群组名称",
  [k.ADD_OWNER]: "添加所有者",
  [k.ADD_CONTACTS]: "添加联系人",
  [k.ADD_TO_GROUP]: "添加到群组",
  [k.APPROVAL_CAN_ONLY_BE_SIGNED_BY]: "审批只能由以下人员签署",
  [k.ENTER_PASSWORD]: "输入密码",
  [k.ENTER_COMMENT_HERE]: "在此输入评论",
  [k.RESENDING_OTP_TO_YOUR_EMAIL]: "重新发送OTP到您的邮箱",
  [k.OTP_SENT_TO_EMAIL]: "OTP已发送到您的邮箱",
  [k.FAILED_TO_SEND_OTP]: "发送OTP失败。请稍后重试",
  [k.ENTER_OTP]: "输入6位数OTP",
  [k.INVITE_RECIPIENTS_TO_UNIFIZE]: "您想邀请收件人加入Unifize吗？",
  [k.SEARCH_PEOPLE_OR_GROUPS]: "搜索人员或群组",
  [k.SELECT_ROLE_FOR_NEW_PARTICIPANT]: "为新参与者选择角色",
  [k.ALL_COMMENTS_AND_MESSAGES]: "所有评论和消息",
  [k.SEARCH_PICKLIST]: "搜索选择列表",
  [k.ENTER_TITLE_FOR_NEW_ITEM]: "为新项目输入标题",
  [k.MARK_AS_FAVOURITE]: "标记为收藏",
  [k.REVISION_PERMISSIONS]: "修订版本权限",
  [k.REVISIONS_CAN_BE_CREATED_BY]: "修订版本只能由以下人员创建",
  [k.REVISION_SETTINGS_NOT_CONFIGURED]: "修订版本设置尚未配置",
  [k.ENTER_YOUR_NAME]: "输入您的姓名",
  [k.NEW_PASSWORD]: "新密码",
  [k.GENERATE_PDF]: "生成PDF",
  [k.MS_ADMIN_NOT_ENABLED]: "Microsoft 365管理员未启用",
  [k.UNABLE_TO_CREATE_FILE]: "无法创建文件",
  [k.MS_NOT_ENABLED]: "Microsoft 365未启用",
  [k.BLANK]: "空白",
  [k.NON_BLANK]: "非空白",
  [k.CANCEL_REQUEST]: "取消请求",
  [k.CANCEL_APPROVAL]: "取消审批",
  [k.OPEN]: "打开",
  [k.ENTER_OPTIONAL_TITLE]: "输入可选标题",
  [k.ENTER_ADDITIONAL_COMMENTS]: "输入附加评论",
  [k.PENDING_INQUIRIES_FOR_STEAM]: "例如：蒸汽涡轮机的待处理询问",
  [k.GRAPHICAL_REPRESENTATION_THE_PENDING_ENQUIRIES]:
    "例如：按所有者分类的蒸汽涡轮机待处理询问的图形表示",
  [k.SELECT_A_CHART_FOR]: "为以下选择图表",
  [k.COUNT_OF_CONVERSATIONS]: "对话计数",
  [k.FOLLOWING_CHARTS_REPRESENT_CONVERSATIONS]: "以下图表表示底层对话的数量",
  [k.COUNT_OF_FORMS]: "表单计数",
  [k.FOLLOWING_CHARTS_REPRESENT_FORMS]: "以下图表表示底层表单的数量",
  [k.SUM_OF_NUMERIC_FIELD]: "数值字段总和",
  [k.USE_CHARTS_FOR_TOTALS]: "当您需要总支出金额或总小时数等时使用这些图表",
  [k.TIME_TRENDS]: "时间趋势",
  [k.USE_CHARTS_FOR_TRENDS]: "当您需要查看计数或值随时间的趋势时使用这些图表",
  [k.COMPARISON_CHART]: "比较图表",
  [k.USE_CHARTS_FOR_COMPARISON]:
    "当您需要比较两个或多个数据集时使用这些图表。例如缺陷率与生产数据",
  [k.PIE_CHART]: "饼图",
  [k.BAR_CHART]: "柱状图",
  [k.CHECKLIST_FIELDS]: "检查表字段",
  [k.CONVERSATION_ATTRIBUTES]: "对话属性",
  [k.REFRESHED_PROCESS_TABLE]: "已刷新流程表",
  [k.NEW_PROCESS_TEMPLATE]: "新流程模板",
  [k.IMPORT]: "导入",
  [k.DISPLAY_NAME]: "名称",
  [k.EMAIL_ID]: "电子邮件ID",
  [k.ROLE1]: "角色",
  [k.DEPARTMENT]: "部门",
  [k.PHONE_NUMBER]: "电话号码",
  [k.GROUPS]: "群组",
  [k.LAST_LOGGED_IN]: "上次登录",
  [k.DATE_INVITED]: "邀请日期",
  [k.DATE_JOINED]: "加入日期",
  [k.SEARCH_FOR_ANYTHING]: "搜索任何内容",
  [k.DATE_UPDATED]: "更新日期",
  [k.PRIORITY]: "优先级",
  [k.STATUS]: "状态",
  [k.DATE_CREATED]: "创建日期",
  [k.ALL_RELATED]: "所有相关",
  [k.OPEN_REVISIONS]: "打开修订版本",
  [k.EXPORT]: "导出",
  [k.REMOVE_CHART_FROM_DASHBOARD]: "从仪表板移除图表",
  [k.REMOVE_CHART]: "移除图表",
  [k.ARE_YOU_SURE_YOU_WANT_TO_REMOVE_CHART]: "您确定要从仪表板中移除此图表吗？",
  [k.TOMORROW]: "明天",
  [k.YESTERDAY]: "昨天",
  [k.ALL_EMBEDDED_RECORDS]: "所有嵌入记录",
  [k.ERROR_MODIFYING_GROUP]: "修改群组出错",
  [k.SEARCH_ORG]: "搜索组织",
  [k.ERROR_CREATING_CONVERSATION]: "创建对话出错",
  [k.DISABLE_AND_CLEAR_ALL_DATA]: "禁用并清除所有数据",
  [k.INVITE_SENT]: "邀请已发送",
  [k.INVITE_CLICKED]: "邀请已点击",
  [k.EMAIL_PASSWORD_REGISTRATION]: "电子邮件ID和密码注册",
  [k.PHONE_DEPT_REGISTRATION]: "电话和部门注册",
  [k.SIGNIN_MOBILE]: "登录（移动）",
  [k.SIGNIN_WEB]: "登录（网页）",
  [k.USE_THIS_SECTION_UPCOMING_TASKS]: "使用此部分显示即将到来的任务",
  [k.HAS_USED_PLATFORM]: "已使用平台",
  [k.IS_PART_OF_GROUP]: "是群组的一部分",
  [k.IS_NOT_PART_OF_GROUP]: "不是群组的一部分",
  [k.UNTITLED_USER_SEGMENT]: "无标题用户分组",
  [k.SEARCH_DOMAINS]: "搜索域名",
  [k.APPS]: "应用",
  [k.APPS_DESCRIPTION]: "与您喜欢的应用集成，提升您的工作流程",
  [k.NO_APPS_FOUND]: "未找到应用",
  [k.UNABLE_FETCH_INTEGRATIONS]: "无法获取集成",
  [k.UPDATE_INTEGRATION_FAILED]: "更新集成失败",
  [k.DISCONNECT_INTEGRATION_FAILED]: "断开集成失败",
  [k.ENTER_TEXT]: "输入文本",
  [k.ENTER_NUMBER]: "输入数字",
  [k.NEW_FORM_TEMPLATE]: "新表单模板",
  [k.SELECT_CHECKLIST_FIELD]: "选择检查表字段",
  [k.ENTER_CONVERSATION_TITLE]: "输入对话标题",
  [k.TURN_OFF_REMINDERS_CONTENT]: "您确定要关闭提醒吗？",
  [k.ENTER_LABEL]: "输入标签",
  [k.THIS_WILL_BE_X_AXIS_SERIES]: "这将是X轴系列",
  [k.UNTITLED_SERIES]: "无标题系列",
  [k.AREA]: "区域",
  [k.RATE]: "比率",
  [k.LINE]: "线条",
  [k.ENTER_TRENDLINE_LABEL]: "输入趋势线标签",
  [k.TOTAL_OF_NUMERICAL_FIELD]: "数值字段总计",
  [k.AVERAGE_OF_NUMERICAL_FIELD]: "数值字段平均值",
  [k.NESTED_FIELDS_DESCRIPTION]:
    "对于嵌套字段，先在表单/链接字段内求和，然后平均结果",
  [k.RECORD_COUNT]: "记录计数",
  [k.SUM]: "总和",
  [k.AVERAGE]: "平均值",
  [k.AVERAGE_OF_SUM]: "总和的平均值",
  [k.ALL_RECORDS_FILTER]: "所有记录过滤器",
  [k.ALL_RECORDS_FILTER_DESCRIPTION]:
    " - 如果此选项已禁用（默认）：只有主流程记录将被过滤 - 即使它包含多个值 - 如果此选项已启用：所有记录也将被过滤，因此您将只看到包含该值的表单记录",
  [k.SEARCH_TYPE]: "搜索类型",
  [k.SUBTITLE]: "副标题",
  [k.YOU_HAVE_PENDING_TASKS]: "例如：您有待处理任务",
  [k.YOU_HAVE_NUM_PENDING_TASKS]: "例如：您有 #num 个待处理任务",
  [k.SEARCH_TILES]: "搜索磁贴",
  [k.SELECT_ITEMS]: "选择项目",
  [k.WRONG_PASSWORD_MESSAGE]:
    "（至少8个字符，1个小写字符，1个大写字符和1个数字字符）",
  [k.CONFIRM_PASSWORD]: "确认密码",
  [k.UNTITLED]: "无标题",
  [k.CREATE_REPORT_TILE]: "创建报告磁贴",
  [k.TILE_TITLE]: "磁贴标题",
  [k.SELECT_REPORT]: "选择报告",
  [k.ADD_REPORT]: "添加报告",
  [k.SEARCH_ROLES]: "搜索角色",
  [k.SEARCH_DEPARTMENTS]: "搜索部门",
  [k.SEARCH_GROUPS]: "搜索群组",
  [k.NO_FILTERS_APPLIED]: "未应用过滤器",
  [k.A_FEW_SECONDS_AGO]: "几秒前",
  [k.A_FEW_MINUTES_AGO]: "几分钟前",
  [k.ABOUT]: "关于",
  [k.SERIES]: "系列",
  [k.CHART]: "图表",
  [k.ENABLED]: "启用",
  [k.DISABLED]: "禁用",
  [k.PLEASE_CONTACT_SUPPORT_TO_ADD_REMOVE_DOMAINS]:
    "请联系支持以添加或删除域名",
  [k.DELETED]: "已删除",
  [k.HIDDEN]: "隐藏",
  [k.MESSAGES]: "消息",
  [k.CHECKLIST_UPDATES]: "检查表更新",
  [k.METADATA_UPDATES]: "元数据更新",
  [k.MY_INBOX]: "我的收件箱",
  [k.NO_LINKED_RECORDS]: "没有链接的记录",
  [k.APPROVAL_REQUESTED]: "已请求批准",
  [k.APPROVAL_CANCELLED]: "批准已被取消",
  [k.BELONGS_TO_ROLE]: `属于角色`,
  [k.REQUESTED]: "已请求",
  [k.CANCELLED]: "已取消",
  [k.AND_REJECTED]: "并拒绝",
  [k.AI_SUGGESTED_CHECKLIST_VALUES_FOR]: "AI建议的检查表值用于",
  [k.AI_CHECKLIST_PREPARATION]:
    "Unifize AI 正在为您准备检查表建议。这只需片刻...",
  [k.INVALID_VALUE]: "无效值",
  [k.BUILD_WITH_AI]: "使用AI构建",
  [k.ADD_TO_CHECKLIST]: "添加到检查表",
  [k.SELECT_DATA_TO_COPY_TO_NEW]: "选择要复制到新修订版本的数据",
  [k.UPDATED_CHECKLIST]: "更新了检查表",
  [k.APPROVAL_PASSWORD_INFO]:
    "要使用基于密码的批准，请前往“个人资料”→“更改密码”设置您的密码。",
  [k.SQUARE_BRACKETS_NOT_ALLOWED]: "不允许使用方括号 '[' 和 ']'",
};
